// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-19T19:03:22.935Z
// Property: Allure at Shavano (ID: 5637285756272640)
// Collections: 20 amenities, 4 floorplans (live), 19 photos, 81 POIs, 2 reviews, 3 virtual tours, 6 office hours, 1 special offers (live), 18 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5637285756272640",
  "property_external_id": "4981180",
  "property_zillow_url": "https://www.zillow.com/homedetails/4601-De-Zavala-Rd-San-Antonio-TX-78249/299595284_zpid/",
  "property_apartments_url": "https://www.apartments.com/allure-at-shavano-san-antonio-tx/ky8tzb8",
  "property_google_business_url": "https://www.google.com/maps/place/The+Village+at+Shavano/@29.5706499,-98.5792266,17z/data=!4m13!1m7!3m6!1s0x865c66cde64e4b73:0x10ec18a4f47683d3!2s4601+De+Zavala+Rd,+San+Antonio,+TX+78249!3b1!8m2!3d29.5706453!4d-98.5770379!3m4!1s0x865c66cde5eb898f:0x74894d69e1bd5b7c!8m2!3d29.5709304!4d-98.5779113",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443872083",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "allure-at-shavano",
  "property_name": "Allure at Shavano",
  "property_website_url": "https://www.allureatshavano.com/",
  "property_domain": "https://www.allureatshavano.com/",
  "property_address": "4601 De Zavala Rd",
  "property_full_address": "4601 De Zavala Rd, San Antonio, TX 78249",
  "property_address_1": "4601 De Zavala Rd",
  "property_address_2": null,
  "property_address_city": "San Antonio",
  "property_address_state": "TX",
  "property_address_zip_full": "78249-2014",
  "property_address_zip": "78249",
  "property_address_country": "US",
  "property_address_county": "Bexar County",
  "property_neighborhood_address": "Woods of Shavano",
  "property_address_latitude": "29.5704965",
  "property_address_longitude": "-98.5772526",
  "property_email": "allure@alapts.com",
  "property_phone": "(210) 408-6888",
  "property_call_tracking_phone": "361-266-1646",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Polished Northwest San Antonio apartments in Woods of Shavano.</strong> Allure at Shavano pairs a tucked-away, tree-lined setting off De Zavala Road with one- and two-bedroom homes featuring granite countertops, tile backsplashes, pantry storage, and everyday conveniences designed for easy living.</p>",
  "property_long_description": "<p><strong>Find a polished Northwest San Antonio apartment setting in Woods of Shavano.</strong> At Allure at Shavano, you’re positioned just off De Zavala Road near I-10, with convenient access to UTSA, USAA, the Medical Center, The Rim, and The Shops at La Cantera—plus nearby green space at Phil Hardberger Park and the Leon Creek Greenway. The setting feels tucked into an established, tree-lined pocket while keeping everyday shopping, dining, and major routes close.</p><p>Choose from one- and two-bedroom <a href=\"/floor-plans\">apartment layouts</a> with modern comforts like granite countertops, tile backsplashes, kitchen pantries, washer and dryer connections, and select homes with wood-style flooring, built-in bookshelves, stainless steel appliances, or bay windows. Beyond your front door, <a href=\"/amenities\">community amenities</a> such as a resort-style pool with sundeck, fitness center, grilling areas, resident WiFi café, package lockers, gated access, storage options, online services, and a dog park help make daily living feel easy, connected, and distinctly Shavano.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8977-3e9c-7349-938a-200c522c4b8e.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool and jacuzzi with lounge chairs and trees",
    "public_id": "019e8977-3e9c-7349-938a-200c522c4b8e",
    "storage_key": "property/5637285756272640/019e8977-3e9c-7349-938a-200c522c4b8e.webp",
    "width": 3072,
    "height": 2300
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "200",
  "property_year_built": "1999",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Pet Fee: $300/pet Non-refundable\nMonthly Pet Rent: $25/pet",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8879190.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://allureatshavano.loftliving.com/login",
  "property_apply_now_url": "https://8879190.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019df5c7-9a86-7209-ab4f-dff4ffcd4fcd.webp",
  "property_primary_logo_media": {
    "alt_text": "Allure logo",
    "public_id": "019df5c7-9a86-7209-ab4f-dff4ffcd4fcd",
    "storage_key": "property/5637285756272640/019df5c7-9a86-7209-ab4f-dff4ffcd4fcd.webp",
    "width": 1510,
    "height": 1510
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019df5c7-9a86-7209-ab4f-dff4ffcd4fcd.webp",
  "property_secondary_logo_media": {
    "alt_text": "Allure logo",
    "public_id": "019df5c7-9a86-7209-ab4f-dff4ffcd4fcd",
    "storage_key": "property/5637285756272640/019df5c7-9a86-7209-ab4f-dff4ffcd4fcd.webp",
    "width": 1510,
    "height": 1510
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019df5c7-9a86-7209-ab4f-dff4ffcd4fcd.webp",
  "property_icon_media": {
    "alt_text": "Allure logo",
    "public_id": "019df5c7-9a86-7209-ab4f-dff4ffcd4fcd",
    "storage_key": "property/5637285756272640/019df5c7-9a86-7209-ab4f-dff4ffcd4fcd.webp",
    "width": 1510,
    "height": 1510
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019df5c7-9a86-7209-ab4f-dff4ffcd4fcd.webp",
  "property_fav_icon_media": {
    "alt_text": "Allure logo",
    "public_id": "019df5c7-9a86-7209-ab4f-dff4ffcd4fcd",
    "storage_key": "property/5637285756272640/019df5c7-9a86-7209-ab4f-dff4ffcd4fcd.webp",
    "width": 1510,
    "height": 1510
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f14eb-3db6-77f6-8292-e441fb624649.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f14eb-3db6-77f6-8292-e441fb624649",
    "storage_key": "property/5637285756272640/019f14eb-3db6-77f6-8292-e441fb624649.webp",
    "width": 1280,
    "height": 1280
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f14eb-2308-7164-a723-d76d6510881b.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f14eb-2308-7164-a723-d76d6510881b",
    "storage_key": "property/5637285756272640/019f14eb-2308-7164-a723-d76d6510881b.webp",
    "width": 1280,
    "height": 1280
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#749ed3",
  "property_secondary_color": "#ae8039",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#016183",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "522 - 937",
  "property_sqft_min": "522",
  "property_sqft_max": "937",
  "property_price_range": "943.33 - 1221.66",
  "property_price_min": "943.33",
  "property_price_max": "1221.66",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/allureatshavano",
  "property_instagram_url": "https://www.instagram.com/allureatshavano",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJj4nr5c1mXIYRfFu94WlNiXQ",
  "property_youtube_url": "https://www.youtube.com/@AllureatShavanoApartments",
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Apartments&find_loc=Shavano+Park%2C+TX",
  "property_tiktok_url": "https://www.tiktok.com/@allureatshavano",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Allure at Shavano",
  "property_home_romance_title": "Embrace Life and Love in Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, polished for San Antonio living.</strong> Allure at Shavano brings together a modern fitness center, resident WiFi café, resort-style pool, sundeck, grilling areas, package lockers, gated access, and online resident services. Inside, one- and two-bedroom apartments feature clean finishes like granite countertops, tile backsplashes, kitchen pantries, and washer/dryer connections, with select homes offering stainless steel appliances, hard-surface flooring, built-in bookcases, or bay windows.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit at Allure at Shavano.</strong> Explore one- and two-bedroom apartments in San Antonio with smart layouts, granite countertops, tile kitchen backsplashes, pantry storage, and washer/dryer connections. Select homes add extras like built-in bookcases, hard-surface flooring, stainless steel appliances, or bay windows—then compare featured plans, pricing, and availability to choose the space that feels right.</p>",
  "property_home_gallery_blurb": "<p><strong>See Allure at Shavano in focus.</strong> Browse sunlit interiors with sliding glass doors, granite-counter kitchens, tile backsplashes, sleek appliance finishes, and built-in bookcase character. Then step outside to oak-shaded pool views, lounge seating, grilling spots, and a mirrored fitness center—just a preview of what’s waiting in the full gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Northwest San Antonio, close to the good stuff.</strong> Allure at Shavano places you near De Zavala Road favorites like H-E-B, Street Taco Company, Rock &amp; Brews, Pinstack, The Dooryard, and Huebner Oaks. Add Salado Creek Greenway, oak-lined Shavano Park scenery, and easy I-10 access, and the neighborhood feels both connected and refreshingly open.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents praise the everyday ease at Allure at Shavano.</strong> Reviews point to a quiet atmosphere, clean move-ins, weekly pest control, and a front office known for being kind, respectful, and “RESPONSIVE!!” Maintenance earns standout mentions, too, with prompt communication, thorough repairs, and proactive follow-up that help make Allure at Shavano feel like a great place to live. Read more to hear the experience in residents’ own words.</p>",
  "property_neighborhood_blurb": "<p><strong>Northwest San Antonio, mapped around your day.</strong> From Allure at Shavano, Woods of Shavano puts you near the everyday rhythm of De Zavala Road—quick grocery runs at H-E-B, tacos at Street Taco Company, live-music energy at Rock &amp; Brews, and easy nights out around Pinstack, The Dooryard, and Huebner Oaks. When you want more open air, Salado Creek Greenway and the oak-canopied Shavano Park area add a Hill Country edge to the city setting, with I-10 close for getting across San Antonio. Explore the pins below, then picture how your favorite stops connect back to home—or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the neighborhood in person.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep your day moving.</strong> At Allure at Shavano, convenience and comfort come together in spaces designed for everyday ease. Start with a workout in the modern fitness center, settle into the resident WiFi café when you need a change of scenery, or make the most of sunny San Antonio afternoons at the resort-style pool, sundeck, and outdoor grilling areas. Package lockers, gated access, online resident services, and available storage add the practical details that help home feel effortless.</p><p>Inside your one- or two-bedroom apartment, polished finishes bring a clean, modern feel—think granite countertops, tile backsplashes, kitchen pantries, washer and dryer connections, and select homes with built-in bookcases, hard-surface flooring, stainless steel appliances, or bay windows. See the spaces for yourself in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Allure at Shavano.</strong><br>Choose a polished one- or two-bedroom apartment with modern finishes in a tucked-away, tree-lined Northwest San Antonio setting—then apply online when you’re ready to make your move.</p>",
  "property_contactus_blurb": "<p><strong>Questions about Allure at Shavano?</strong> Contact our leasing team for help with directions, availability, or choosing a one- or two-bedroom layout in our polished Woods of Shavano setting just off De Zavala Road. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Allure at Shavano?</strong> You’re in the right place. Explore quick answers about the community, leasing, apartment features, and everyday living in this polished Woods of Shavano setting. If you need anything else, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the layout that fits your day-to-day.</strong> Allure at Shavano offers one- and two-bedroom apartment floor plans in San Antonio, with efficient options for streamlined living and larger two-bath layouts when you want more breathing room. As you compare availability, look for the interior details that make each home feel complete: granite countertops, tile kitchen backsplashes, pantry storage, washer and dryer connections, and select homes with built-in bookcases, hard-surface flooring, stainless steel appliances, or bay windows. Browse the floor plan cards below to compare layouts, pricing, and move-in dates, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your preferred space in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture your next view.</strong> The Allure at Shavano photo gallery brings the community into focus—from sunlight spilling through sliding glass doors to kitchens framed by granite counters, tile backsplashes, and sleek appliance finishes.</p><p>Scroll from comfortable living rooms with built-in bookcase character to bedrooms, baths, and everyday details that help each one- and two-bedroom layout feel complete. Outdoors, the camera lingers on an oak-shaded <a href=\"/amenities\">resort-style pool</a>, lounge seating, grilling spots, and a fitness center lined with mirrors and cardio equipment. Explore the photos, compare your favorite spaces with the <a href=\"/floor-plans\">available floor plans</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Allure at Shavano in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Allure at Shavano on the map.</strong> See available apartments in a tree-lined Woods of Shavano setting, then zoom out to nearby shopping, dining, green space, and I-10 access along De Zavala Road. Start with <a href=\"/floor-plans\">floor plans</a> or explore the <a href=\"/neighborhood\">neighborhood</a>.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, routines, and easy days.</strong> At Allure at Shavano, your cat or dog can settle into apartment living with space to stretch, no weight limit, and a pet-friendly setting designed for everyday convenience. Take playtime to the on-site dog park, head out for a neighborhood walk, or come home to practical apartment features like hard-surface flooring in select homes and washer and dryer connections that help keep life moving.</p><p>When questions come up about breed guidelines, fees, or choosing the right layout for you and your pets, the leasing team is here to help. Explore our <a href=\"/amenities\">pet-friendly amenities</a>, compare <a href=\"/floor-plans\">available floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Allure at Shavano fits your routine.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Allure at Shavano experience.</strong> Invite friends to discover polished one- and two-bedroom apartments in a tree-lined Northwest San Antonio setting, with modern finishes and connected community spaces that make everyday living feel easy, comfortable, and distinctly Shavano.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Allure at Shavano.</strong><br>Use the online services portal to pay rent, submit maintenance requests, and manage your account from one convenient place—part of a polished Northwest San Antonio setting designed to keep daily living easy, connected, and distinctly Shavano.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents are saying about Allure at Shavano.</strong> Reviews highlight the details that make day-to-day apartment living feel smoother: a quiet ambiance, clean move-in experience, weekly pest control, and a front office described as kind, respectful, and “RESPONSIVE!!”</p><p>You’ll also see frequent appreciation for the maintenance team, especially prompt communication, thorough repairs, and proactive follow-up. From the leasing process to service requests, residents call out staff members by name and credit the team for making Allure at Shavano a “great place to live.” Explore the reviews below to see the experience in their own words.</p>",
  "property_created_at": "1752256357244",
  "property_scheduletour_blurb": "<p><strong>See the Shavano setting for yourself.</strong> Tour polished one- and two-bedroom apartments with granite countertops, tile backsplashes, kitchen pantries, and thoughtful select-home finishes. Then explore the tree-lined community atmosphere, resort-style pool, fitness center, and easy everyday conveniences in person. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we’ve received your inquiry.</strong><br>Our leasing team will follow up soon with next steps. In the meantime, picture polished Northwest San Antonio living with modern one- and two-bedroom layouts, everyday conveniences, and a tucked-away, tree-lined setting near the routes, shopping, and dining that keep life moving.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through the details from wherever you are.</strong> The Allure at Shavano virtual tours let you move room by room through the two-bedroom, two-bath apartment tour, then step into community spaces like the fitness center and clubhouse before planning your visit in San Antonio. Look for the everyday pieces that matter in motion: an open living area, built-in shelving, a bright patio connection, granite-style kitchen finishes, and the way shared spaces feel when you can turn, pause, and explore at your own pace. Start with the tours below, compare options on the <a href=\"/floor-plans\">floor plans</a> page, then <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see more.</p>",
  "property_copyright": "2026 All Rights Reserved. Allure at Shavano",
  "property_seo_title_home": "Allure at Shavano |  Apartments in San Antonio, TX",
  "property_seo_description_home": "Experience modern living at Allure at Shavano in San Antonio! Enjoy spacious floor plans, top-notch amenities, and a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | San Antonio, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect fit at Allure at Shavano in San Antonio, TX. Browse our stunning one- and two-bedroom floor plans crafted for modern living!",
  "property_seo_title_amenities": "Amenities | San Antonio, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover modern living at Allure at Shavano! Stylish layouts, top amenities like a fitness center and bark park await your dream home in San Antonio.",
  "property_seo_title_gallery": "Gallery | Apartments in San Antonio, TX",
  "property_seo_description_gallery": "Experience life at Allure at Shavano in San Antonio, TX! Enjoy elegant amenities, stunning floor plans, and vibrant community spaces designed just for you.",
  "property_seo_title_virtualtours": "Virtual Tours | Allure at Shavano Apartments",
  "property_seo_description_virtualtours": "Step inside Allure at Shavano in San Antonio, TX. Experience our one and two-bedroom apartments through an immersive virtual tour. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Allure at Shavano Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Allure at Shavano in San Antonio! Explore stylish one and two-bedroom apartments with our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in San Antonio, TX",
  "property_seo_description_neighborhood": "Uncover the vibrant life outside Allure at Shavano! Discover local favorites, unique spots, and the best of San Antonio just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Allure at Shavano",
  "property_seo_description_contact": "Connect with the friendly leasing team at Allure at Shavano in San Antonio, TX. Inquire about our stylish one- and two-bedroom apartments today!",
  "property_seo_title_faqs": "FAQs | Apartments in San Antonio, TX",
  "property_seo_description_faqs": "Uncover vital details about Allure at Shavano's community amenities, floor plans, and more. Your ideal San Antonio living experience awaits! Browse FAQs now.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in San Antonio, TX",
  "property_seo_description_reviews": "Uncover the charm of Allure at Shavano in San Antonio, TX! Residents praise our stylish amenities, from a fitness center to a bark park. Join our community!",
  "property_seo_title_applynow": "Apply Now | Apartments in San Antonio, TX",
  "property_seo_description_applynow": "Elevate your lifestyle at Allure at Shavano! Choose stylish one or two-bedroom apartments with luxurious amenities like a pool and fitness center!",
  "property_seo_title_residentaccess": "Resident Access | Allure at Shavano",
  "property_seo_description_residentaccess": "Unlock convenience at Allure at Shavano! Access your resident portal for easy rent payment, maintenance requests, and more. Your home, your control!",
  "property_seo_title_referafriend": "Refer A Friend | Allure at Shavano",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Allure at Shavano in San Antonio, TX, and enjoy the perks of community living together.",
  "property_seo_title_scheduletour": "Schedule a Tour | Allure at Shavano",
  "property_seo_description_scheduletour": "Experience the charm of Allure at Shavano in San Antonio, TX. Schedule your personalized tour today and envision your life in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Allure at Shavano",
  "property_seo_description_privacy": "Safeguarding your privacy is our priority at Allure at Shavano. Dive into our policies and find out how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Allure at Shavano",
  "property_seo_description_accessibility": "At Allure at Shavano in San Antonio, we prioritize accessibility for all. Experience seamless living in a community that champions digital inclusion.",
  "property_seo_title_sitemap": "Sitemap | Allure at Shavano",
  "property_seo_description_sitemap": "Uncover every corner of Allure at Shavano in San Antonio. Our sitemap guides you through exclusive amenities, floor plans, and community offerings.",
  "property_seo_title_thankyou": "Thank You | Allure at Shavano",
  "property_seo_description_thankyou": "Thank you for reaching out! Your interest in Allure at Shavano in San Antonio, TX is appreciated. Expect a prompt response from our team soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Buford, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319338",
  "amenities": [
    {
      "id": "custom_98e17890-65ab-469b-a4d3-62feec768dfb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b115722b-83b5-4a4b-859f-98d9e60c6922",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Electronic Front Door Access",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3aea5920-43fb-43af-8410-b6b21eae24f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_78e44dd9-5ead-4cbd-83c2-8a5bcf212ae7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000604",
      "title": "Built-In Bookcase",
      "amount": "0.0000",
      "description": "Built-In Bookshelves*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5a1045ac-d0b1-4f8a-ab90-2a5a9339aad9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000606",
      "title": "Built-In Microwave",
      "amount": "0.0000",
      "description": "Built-In Microwave**",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_22723edb-bfc1-4c7d-a160-99b9a3a55c6a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_296730c2-b153-4574-bea8-434cd4c48ff2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_26e08c68-2d27-40d7-b9f3-615f256d3ceb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1a99324a-0a24-467d-bb43-db5350623b04",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Resident Outdoor Grilling Areas",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1e63d652-10b2-44b6-b79d-4070e201da03",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Faux Wood Flooring*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d8b40886-243b-4bf8-b426-93e171bd6999",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances**",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9920e428-800b-46da-839d-0292818aff82",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_367c23bf-abfa-4d39-9195-ec90d05fe47b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000666",
      "title": "Pantry Closets",
      "amount": "0.0000",
      "description": "Kitchen Pantries*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_51689870-0a37-4d61-a7e7-4ae0ce36a96a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort Style Pool w/Sundeck",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f9bc981c-e14b-41e5-844e-a1029022670a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_362af285-ce86-4500-8d63-bd09d9fa14f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000687",
      "title": "Storage Spaces",
      "amount": "0.0000",
      "description": "Onsite Storage Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a5fa2332-4bac-4700-ae3a-bf8598047449",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Tile Backsplash in Kitchen",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_62051a36-9a0f-41e8-a5ef-0b5d891baf54",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000703",
      "title": "W&D Connections",
      "amount": "0.0000",
      "description": "Washer & Dryer Hookups",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e6e16865-422b-44c4-91ef-72339e8c7e0d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000000710",
      "title": "Windows",
      "amount": "0.0000",
      "description": "Bay Windows*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fdb3bd92-4c6f-4966-b6f4-3f21bf7c4db1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "external_id": "P000002384",
      "title": "Cyber Cafe",
      "amount": "0.0000",
      "description": "Resident WiFi Caf & Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_6823b027-58d2-42c7-888a-f600bfc8065a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8978-8283-77cd-bf29-76989d81691c.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with treadmills, rowing machine, and weight machines.",
        "public_id": "019e8978-8283-77cd-bf29-76989d81691c",
        "storage_key": "property/5637285756272640/019e8978-8283-77cd-bf29-76989d81691c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment, strength training machines, and free weights. Your healthy lifestyle awaits!",
      "link": "",
      "alt_text": "Modern apartment gym with treadmills, rowing machine, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7d72436d-dfa7-4900-a19e-70bee144641e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8978-816a-769a-9129-1fc2f5a75cae.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and nightstand.",
        "public_id": "019e8978-816a-769a-9129-1fc2f5a75cae",
        "storage_key": "property/5637285756272640/019e8978-816a-769a-9129-1fc2f5a75cae.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, elegant dresser, and stylish nightstand.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, dresser, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8fef21ca-ba07-4bfd-97df-554d1b856ed7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8978-810e-7799-b86c-d0e77584d896.webp",
      "image_media": {
        "alt_text": "Living room with a white sofa, coffee table, armchair, and TV.",
        "public_id": "019e8978-810e-7799-b86c-d0e77584d896",
        "storage_key": "property/5637285756272640/019e8978-810e-7799-b86c-d0e77584d896.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable white sofa, a modern coffee table, and a cozy armchair, perfect for relaxation.",
      "link": "",
      "alt_text": "Living room with a white sofa, coffee table, armchair, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2610d137-9f19-41ba-a9ff-d7981fdfe48e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8978-810e-7799-b86c-cc1f2942c1dc.webp",
      "image_media": {
        "alt_text": "Modern bathroom with gray vanity, granite countertop, and white bathtub.",
        "public_id": "019e8978-810e-7799-b86c-cc1f2942c1dc",
        "storage_key": "property/5637285756272640/019e8978-810e-7799-b86c-cc1f2942c1dc.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bathroom featuring a sleek gray vanity, elegant granite countertops, and a pristine white bathtub, perfect for unwinding.",
      "link": "",
      "alt_text": "Modern bathroom with gray vanity, granite countertop, and white bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e62c2643-cd91-409c-814b-e6ed30792acb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8978-80bc-73a1-9d5e-ee33ad0f9401.webp",
      "image_media": {
        "alt_text": "Amenity area with coffee station and seating",
        "public_id": "019e8978-80bc-73a1-9d5e-ee33ad0f9401",
        "storage_key": "property/5637285756272640/019e8978-80bc-73a1-9d5e-ee33ad0f9401.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and refreshments in our resident lounge area. Perfect for a morning pick-me-up or a midday break.",
      "link": "",
      "alt_text": "Amenity area with coffee station and seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5c2a4bf0-fae7-4ad4-83f8-f9ca810ec4d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8978-3628-75bf-9a90-1479cb33a431.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees.",
        "public_id": "019e8978-3628-75bf-9a90-1479cb33a431",
        "storage_key": "property/5637285756272640/019e8978-3628-75bf-9a90-1479cb33a431.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool and relax in the adjacent hot tub, surrounded by lush trees and comfortable lounge seating.",
      "link": "",
      "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9db43189-000e-4797-8dc6-94999e3b7d36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8978-264c-7620-8b77-46f454b5e16b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and gray cabinets.",
        "public_id": "019e8978-264c-7620-8b77-46f454b5e16b",
        "storage_key": "property/5637285756272640/019e8978-264c-7620-8b77-46f454b5e16b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space for all your cooking needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and gray cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec5e6b87-6026-4dd2-af18-09284629d5d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8977-3e3c-712e-a3cf-871484d38007.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with a hot tub and lounge chairs.",
        "public_id": "019e8977-3e3c-712e-a3cf-871484d38007",
        "storage_key": "property/5637285756272640/019e8977-3e3c-712e-a3cf-871484d38007.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, featuring a soothing hot tub and ample lounge seating surrounded by lush greenery.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with a hot tub and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a9a32e76-d169-4ca9-a452-442b28a38597",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8977-4f93-714c-bcc7-f222ec4c31f6.webp",
      "image_media": {
        "alt_text": "Oasis-style pool and spa with lounge chairs and lush trees.",
        "public_id": "019e8977-4f93-714c-bcc7-f222ec4c31f6",
        "storage_key": "property/5637285756272640/019e8977-4f93-714c-bcc7-f222ec4c31f6.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Relax and unwind at our stunning oasis-style pool and spa, surrounded by lush trees and comfortable lounge chairs. Perfect for a sunny day escape.",
      "link": "",
      "alt_text": "Oasis-style pool and spa with lounge chairs and lush trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f8fbb65e-c436-4b4f-83cf-3cdc9274a3be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8977-3e9c-7349-938a-200c522c4b8e.webp",
      "image_media": {
        "alt_text": "Swimming pool and jacuzzi with lounge chairs and trees",
        "public_id": "019e8977-3e9c-7349-938a-200c522c4b8e",
        "storage_key": "property/5637285756272640/019e8977-3e9c-7349-938a-200c522c4b8e.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Relax by our sparkling swimming pool and soothing jacuzzi. Plenty of lounge chairs and shaded areas available.",
      "link": "",
      "alt_text": "Swimming pool and jacuzzi with lounge chairs and trees",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_093495d1-5ed8-4534-81b7-dc34418d2327",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8977-2d79-759c-8476-b17c5b6e2dba.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with lush greenery and a swimming pool.",
        "public_id": "019e8977-2d79-759c-8476-b17c5b6e2dba",
        "storage_key": "property/5637285756272640/019e8977-2d79-759c-8476-b17c5b6e2dba.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Discover comfortable living in this apartment community, featuring a refreshing swimming pool and ample green spaces.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with lush greenery and a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3a71b1d1-e604-4a5e-b06b-473a397ec232",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8977-2d01-77a1-89c1-1b5d04311c44.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot and landscaping.",
        "public_id": "019e8977-2d01-77a1-89c1-1b5d04311c44",
        "storage_key": "property/5637285756272640/019e8977-2d01-77a1-89c1-1b5d04311c44.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Aerial view of apartment buildings showcasing the exterior architecture, parking facilities, and surrounding greenery.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a parking lot and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_651e6f95-f77a-4c5e-8eb2-f992d7167ef8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8977-2d00-701b-bc03-6922ed07dd49.webp",
      "image_media": {
        "alt_text": "Cozy dining nook with a high-top table and chairs next to a decorative shelving unit.",
        "public_id": "019e8977-2d00-701b-bc03-6922ed07dd49",
        "storage_key": "property/5637285756272640/019e8977-2d00-701b-bc03-6922ed07dd49.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy a charming dining nook, perfect for intimate meals or morning coffee, complemented by stylish shelving for your decor.",
      "link": "",
      "alt_text": "Cozy dining nook with a high-top table and chairs next to a decorative shelving unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b03e897-33f2-4442-ac49-fb8ab6110f35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8977-2d6a-778d-b0b5-1174b4e9c15f.webp",
      "image_media": {
        "alt_text": "Treadmills, rowing machine, and elliptical in a fitness center.",
        "public_id": "019e8977-2d6a-778d-b0b5-1174b4e9c15f",
        "storage_key": "property/5637285756272640/019e8977-2d6a-778d-b0b5-1174b4e9c15f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center, featuring treadmills, a rowing machine, and an elliptical.",
      "link": "",
      "alt_text": "Treadmills, rowing machine, and elliptical in a fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_79e999cc-91e6-42b5-8e9f-0ef669164a13",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8977-240e-709a-ba7d-7abb45688e80.webp",
      "image_media": {
        "alt_text": "Living room with a TV, coffee table, and a view of the bedroom.",
        "public_id": "019e8977-240e-709a-ba7d-7abb45688e80",
        "storage_key": "property/5637285756272640/019e8977-240e-709a-ba7d-7abb45688e80.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room with a large TV, a wooden coffee table, and a comfortable armchair. Access to a private balcony and an adjoining bedroom.",
      "link": "",
      "alt_text": "Living room with a TV, coffee table, and a view of the bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c6a74bb-3c37-4181-83df-40d9b35f37ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8977-24d9-710a-bbd9-56ff4be64320.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, dresser, and decorative art.",
        "public_id": "019e8977-24d9-710a-bbd9-56ff4be64320",
        "storage_key": "property/5637285756272640/019e8977-24d9-710a-bbd9-56ff4be64320.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a plush queen-sized bed, elegant dresser, and tasteful wall art for a serene ambiance.",
      "link": "",
      "alt_text": "Bedroom with a queen-sized bed, dresser, and decorative art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2b92d299-c77a-44b4-b1d8-6dedd03dd1f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8977-3c00-7642-b041-f3b090e6883d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and walk-in closet.",
        "public_id": "019e8977-3c00-7642-b041-f3b090e6883d",
        "storage_key": "property/5637285756272640/019e8977-3c00-7642-b041-f3b090e6883d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a sleek vanity with ample storage, a comfortable toilet, and a convenient walk-in closet for all your storage needs.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_646981ce-1143-423c-bcf2-ce4f664d5729",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8977-33be-7162-91fe-a907d09cc9cf.webp",
      "image_media": {
        "alt_text": "Spacious living room with a stone fireplace, modern furniture, and a view into the kitchen and dining area.",
        "public_id": "019e8977-33be-7162-91fe-a907d09cc9cf",
        "storage_key": "property/5637285756272640/019e8977-33be-7162-91fe-a907d09cc9cf.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax in this inviting living space featuring a grand stone fireplace, comfortable seating, and a seamlessly integrated kitchen and dining area. Perfect for unwinding or entertaining.",
      "link": "",
      "alt_text": "Spacious living room with a stone fireplace, modern furniture, and a view into the kitchen and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_62004ab7-ef3a-4dec-8449-3e3cbacc003f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019e8977-247a-741f-bdba-b10e6be8cc12.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, granite countertops, stainless steel appliances, and a tile backsplash.",
        "public_id": "019e8977-247a-741f-bdba-b10e6be8cc12",
        "storage_key": "property/5637285756272640/019e8977-247a-741f-bdba-b10e6be8cc12.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "This contemporary kitchen features sleek gray cabinetry, elegant granite countertops, and a stylish tile backsplash, complemented by stainless steel appliances for a touch of modern sophistication.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, granite countertops, stainless steel appliances, and a tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_7b8ee0456c20de98568ce94b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Royal Pizza",
      "poi_type": "Restaurants",
      "poi_address": "4415 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Pizzeria doling out Swedish-style, thin-crust pies with a variety of toppings, plus salads & kebabs.",
      "poi_long_description": "Pizzeria doling out Swedish-style, thin-crust pies with a variety of toppings, plus salads & kebabs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-b9da-7673-ba08-39ee1a49333d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-b9da-7673-ba08-39ee1a49333d",
        "storage_key": "property/5637285756272640/019f1515-b9da-7673-ba08-39ee1a49333d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://royalpizzashavano.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=4866535516770408018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "royal-pizza",
      "poi_latitude": "29.5716859",
      "poi_longitude": "-98.5731339",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-399-2220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
      "poi_map_icon_media": {
        "alt_text": "A graphic icon of a fork and knife.",
        "public_id": "019d64bb-19d6-763b-bf8b-f54454596b4a",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbwKM3v9mXIYRUhbsu0RoiUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_2a5de2183ea69dc0465e276f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Taqueria Datapoint-#3 -De Zavala Road Location",
      "poi_type": "Restaurants",
      "poi_address": "4503 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Casual Mexican joint specializing in breakfast tacos and other comfort food, plus beer.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-b4a2-70df-9f1f-ea25148f5cd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-b4a2-70df-9f1f-ea25148f5cd6",
        "storage_key": "property/5637285756272640/019f1515-b4a2-70df-9f1f-ea25148f5cd6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.taqueriadatapointdezavalard.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=710816748995382443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taqueria-datapoint-3--de-zavala-road-location",
      "poi_latitude": "29.5710482",
      "poi_longitude": "-98.5747208",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-455-3888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
      "poi_map_icon_media": {
        "alt_text": "A graphic icon of a fork and knife.",
        "public_id": "019d64bb-19d6-763b-bf8b-f54454596b4a",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbwKhPHVnXIYRq4xEMBFU3Qk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_f473790f44294437bfe8aa52",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "DeZavala Icehouse",
      "poi_type": "Restaurants",
      "poi_address": "4503 De Zavala Rd Ste 108, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-b78b-734f-817c-9ffedd093e9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-b78b-734f-817c-9ffedd093e9f",
        "storage_key": "property/5637285756272640/019f1515-b78b-734f-817c-9ffedd093e9f.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "https://www.dezavalaicehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9275938144836569076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dezavala-icehouse",
      "poi_latitude": "29.5706492",
      "poi_longitude": "-98.5748086",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1516-34e2-723a-805b-2e0ed6350180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1516-34e2-723a-805b-2e0ed6350180",
        "storage_key": "property/5637285756272640/019f1516-34e2-723a-805b-2e0ed6350180.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvZA3gQhnXIYR9Md6wZjAuoA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_b9abe732a48c6b139cc43009",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "5189 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-baf7-7026-a3c8-e7cc4e0b28e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-baf7-7026-a3c8-e7cc4e0b28e8",
        "storage_key": "property/5637285756272640/019f1515-baf7-7026-a3c8-e7cc4e0b28e8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/tx/dezavala-road?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5647398750385091203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "29.5656775",
      "poi_longitude": "-98.5855286",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-699-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
      "poi_map_icon_media": {
        "alt_text": "A graphic icon of a fork and knife.",
        "public_id": "019d64bb-19d6-763b-bf8b-f54454596b4a",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdwExTtpmXIYRgzKwBT6XX04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_a71fcad0b6eb123cda29e7de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "KABAYAN KUSINA",
      "poi_type": "Restaurants",
      "poi_address": "5238 De Zavala Rd #124, San Antonio, TX 78249, USA",
      "poi_short_description": "Casual eatery serving classic Filipino dishes such as lumpia, lechon and sisig.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-b968-77d9-9c6e-78aea1a60a06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-b968-77d9-9c6e-78aea1a60a06",
        "storage_key": "property/5637285756272640/019f1515-b968-77d9-9c6e-78aea1a60a06.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/kabayankusinasatx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17529516509045780104&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kabayan-kusina",
      "poi_latitude": "29.5633635",
      "poi_longitude": "-98.5882761",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-900-7145",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
      "poi_map_icon_media": {
        "alt_text": "A graphic icon of a fork and knife.",
        "public_id": "019d64bb-19d6-763b-bf8b-f54454596b4a",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc6RzZ_xnXIYRiO4EvmNaRfM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "filipino_restaurant"
    },
    {
      "id": "ec_b24c538b88d9c08775a0e62a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "EZ's Brick Oven",
      "poi_type": "Restaurants",
      "poi_address": "12922 Potranco Rd, San Antonio, TX 78245, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-ba20-735e-9fb8-8c161a7ce467.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-ba20-735e-9fb8-8c161a7ce467",
        "storage_key": "property/5637285756272640/019f1515-ba20-735e-9fb8-8c161a7ce467.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ezsrestaurants.com/menu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6099166835586000631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ezs-brick-oven",
      "poi_latitude": "29.428303",
      "poi_longitude": "-98.748428",
      "poi_miles_from_property": "18.3 mi",
      "poi_walking_minutes": "6 hours 50 mins",
      "poi_biking_minutes": "1 hour 54 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 210-750-1227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
      "poi_map_icon_media": {
        "alt_text": "A graphic icon of a fork and knife.",
        "public_id": "019d64bb-19d6-763b-bf8b-f54454596b4a",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9224PwBBXIYR92byFOyXpFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_f72d6c7210ef2e828affab09",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "JINYA Ramen Bar -San Antonio",
      "poi_type": "Restaurants",
      "poi_address": "5311 N Loop 1604 W Ste 101, San Antonio, TX 78249, USA",
      "poi_short_description": "Contemporary Japanese ramen restaurant featuring a customizable menu and sleek interior.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-b95c-7083-87ce-bb5eca157c38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-b95c-7083-87ce-bb5eca157c38",
        "storage_key": "property/5637285756272640/019f1515-b95c-7083-87ce-bb5eca157c38.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.jinyaramenbar.com/locations/san-antonio/?utm_medium=soci&utm_source=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17528122879230167386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jinya-ramen-bar--san-antonio",
      "poi_latitude": "29.593412",
      "poi_longitude": "-98.5901589",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-251-2519",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
      "poi_map_icon_media": {
        "alt_text": "A graphic icon of a fork and knife.",
        "public_id": "019d64bb-19d6-763b-bf8b-f54454596b4a",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_QtlK7BnXIYRWknpA-RmQPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_043db19e23c75c9083316b44",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Broadway Daily Bread",
      "poi_type": "Restaurants",
      "poi_address": "5011 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Bakery offering fresh breads, sweet & savory pastries, plus a lunch menu of sandwiches & salads.",
      "poi_long_description": "Bakery offering fresh breads, sweet & savory pastries, plus a lunch menu of sandwiches & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-b973-7400-9c3b-2ace2d13428b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-b973-7400-9c3b-2ace2d13428b",
        "storage_key": "property/5637285756272640/019f1515-b973-7400-9c3b-2ace2d13428b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.broadwaybread.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2081020456212751307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broadway-daily-bread",
      "poi_latitude": "29.5678644",
      "poi_longitude": "-98.5802027",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-697-0020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
      "poi_map_icon_media": {
        "alt_text": "A graphic icon of a fork and knife.",
        "public_id": "019d64bb-19d6-763b-bf8b-f54454596b4a",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ26l-ytFmXIYRy-PhRhRF4Rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_2f80d6d6eeefd82409410899",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Dutch Bros Coffee",
      "poi_type": "Restaurants",
      "poi_address": "6394 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Fun-loving drive-thru serving up customized coffees, Rebel energy drinks, cold brew, tea & more.",
      "poi_long_description": "Fun-loving drive-thru serving up customized coffees, Rebel energy drinks, cold brew, tea & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-b51b-74f1-8d0e-4428a9091a78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-b51b-74f1-8d0e-4428a9091a78",
        "storage_key": "property/5637285756272640/019f1515-b51b-74f1-8d0e-4428a9091a78.webp",
        "width": 959,
        "height": 1280
      },
      "poi_business_url": "https://www.dutchbros.com/locations/tx/san-antonio/6394-de-zavala-rd?y_source=1_NzI3NDY5NjktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10213279131870515534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dutch-bros-coffee",
      "poi_latitude": "29.5624115",
      "poi_longitude": "-98.6132167",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 877-899-2767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c6-2289-77ff-82d2-3f4e5f03fd08.webp",
      "poi_map_icon_media": {
        "alt_text": "Coffee cup icon",
        "public_id": "019d64c6-2289-77ff-82d2-3f4e5f03fd08",
        "storage_key": "property/5637285756272640/019d64c6-2289-77ff-82d2-3f4e5f03fd08.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ77wwLEpnXIYRTlENF0LbvI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_8dd7f2349a438c49ea0a9101",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "5836 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-09f6-700e-bfae-286c7029a6ae.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Culver's restaurant with a white car parked in front.",
        "public_id": "019d64c5-09f6-700e-bfae-286c7029a6ae",
        "storage_key": "property/5637285756272640/019d64c5-09f6-700e-bfae-286c7029a6ae.webp",
        "width": 2307,
        "height": 3072
      },
      "poi_business_url": "http://www.culvers.com/restaurants/san-antonio/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=8144155121713565266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "29.5625845",
      "poi_longitude": "-98.5987614",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-558-9797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
      "poi_map_icon_media": {
        "alt_text": "A graphic icon of a fork and knife.",
        "public_id": "019d64bb-19d6-763b-bf8b-f54454596b4a",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ70QmsuZmXIYRUk5qAe_ZBXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_658707993fe63558dcf6866e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Artea Bubble Tea + Eats",
      "poi_type": "Restaurants",
      "poi_address": "6362 De Zavala Rd #108, San Antonio, TX 78249, USA",
      "poi_short_description": "Cozy eatery featuring Taiwanese grub such as fried rice, potstickers and tea-based eats.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-0a88-710a-950f-a1f4ad8a1dcf.webp",
      "poi_featured_image_media": {
        "alt_text": "Modern interior of a restaurant with people dining and a bar area.",
        "public_id": "019d64c5-0a88-710a-950f-a1f4ad8a1dcf",
        "storage_key": "property/5637285756272640/019d64c5-0a88-710a-950f-a1f4ad8a1dcf.webp",
        "width": 2600,
        "height": 1733
      },
      "poi_business_url": "https://www.drinkartea.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14942728900446528137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "artea-bubble-tea--eats",
      "poi_latitude": "29.5626159",
      "poi_longitude": "-98.6118061",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-462-1388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA0J4FvlmXIYRiSIU1sM8X88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tea_house"
    },
    {
      "id": "ec_0d073c699d1bb821e820e8db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Maíz Cocina Mexicana",
      "poi_type": "Restaurants",
      "poi_address": "923 N Loop 1604 E #101, San Antonio, TX 78232, USA",
      "poi_short_description": "Casual eatery for breakfast, brunch and lunch, plus a menu of traditional Mexican fare.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-c3fe-7367-b129-259aceec445f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-c3fe-7367-b129-259aceec445f",
        "storage_key": "property/5637285756272640/019f1515-c3fe-7367-b129-259aceec445f.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://maizsatx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12850494946072885516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maz-cocina-mexicana",
      "poi_latitude": "29.6111003",
      "poi_longitude": "-98.4795453",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-848-3284",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
      "poi_map_icon_media": {
        "alt_text": "A graphic icon of a fork and knife.",
        "public_id": "019d64bb-19d6-763b-bf8b-f54454596b4a",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4SjzFwCJXIYRDHmgkBEhVrI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_b2c8332b5402f9ca85895fd6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "SILO Elevated Cuisine - 1604",
      "poi_type": "Restaurants",
      "poi_address": "434 N Loop 1604 W, Building 1, Suite 1106, 434 N Loop 1604 W Bldg 1,1106, San Antonio, TX 78232, USA",
      "poi_short_description": "Elevated bistro with inspired New American fare, wine & brunch, plus a bar scene on the lower level.",
      "poi_long_description": "Elevated bistro with inspired New American fare, wine & brunch, plus a bar scene on the lower level.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-c0dc-74cd-b064-f720e5de3e53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-c0dc-74cd-b064-f720e5de3e53",
        "storage_key": "property/5637285756272640/019f1515-c0dc-74cd-b064-f720e5de3e53.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://siloelevatedcuisine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8229651345597036974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "silo-elevated-cuisine---1604",
      "poi_latitude": "29.6074623",
      "poi_longitude": "-98.5008788",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 210-483-8989",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
      "poi_map_icon_media": {
        "alt_text": "A graphic icon of a fork and knife.",
        "public_id": "019d64bb-19d6-763b-bf8b-f54454596b4a",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7_t5_VhXIYRrnmg10uYNXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "ec_3f506899e395c22062477f10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4226 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Compact grocery offering organic and allergy-friendly options, along with self-service checkouts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-2c77-747d-934d-33ab574024a5.webp",
      "poi_featured_image_media": {
        "alt_text": "Walmart Neighborhood Market exterior with entrance and parking lot.",
        "public_id": "019d64c5-2c77-747d-934d-33ab574024a5",
        "storage_key": "property/5637285756272640/019d64c5-2c77-747d-934d-33ab574024a5.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.walmart.com/store/5224-san-antonio-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=503761694181197674&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "29.5745505",
      "poi_longitude": "-98.5658218",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-774-2734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-4d00bd416192.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d64bb-19c4-767d-b643-4d00bd416192",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-4d00bd416192.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbUuI_jNhXIYRaocegZe4_QY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_594a74af15d8a7e169497cfe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "5555 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Department store chain supplying diverse merchandise including clothing, electronics, and home furnishings, plus groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-cd66-712a-84c0-9f6dc39a17c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-cd66-712a-84c0-9f6dc39a17c0",
        "storage_key": "property/5637285756272640/019f1515-cd66-712a-84c0-9f6dc39a17c0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/2599-san-antonio-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14022366778729904471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "29.5644288",
      "poi_longitude": "-98.5959705",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-558-2007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f9876b02e7ce.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smile",
        "public_id": "019d64bb-19d6-763b-bf8b-f9876b02e7ce",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f9876b02e7ce.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk-cSSOdmXIYRVzlvpEp0mcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_02fb445c30eb37aac032d957",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "5565 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-c3ec-7059-8918-dcdbfd5af540.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-c3ec-7059-8918-dcdbfd5af540",
        "storage_key": "property/5637285756272640/019f1515-c3ec-7059-8918-dcdbfd5af540.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/6262-san-antonio-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6834653668932591681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "29.5670499",
      "poi_longitude": "-98.5957958",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-641-4810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f9876b02e7ce.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smile",
        "public_id": "019d64bb-19d6-763b-bf8b-f9876b02e7ce",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f9876b02e7ce.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHXtKv-dmXIYRQSCM40yR2V4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_452dab92594d83b58aedac32",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "5611 UTSA Boulevard, San Antonio, TX 78249, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-c70d-733b-8032-5c6d9c4d7ae1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-c70d-733b-8032-5c6d9c4d7ae1",
        "storage_key": "property/5637285756272640/019f1515-c70d-733b-8032-5c6d9c4d7ae1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/san-antonio-TX-689.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=5533508928880452707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "29.5760153",
      "poi_longitude": "-98.5975163",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-200-2050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f9876b02e7ce.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smile",
        "public_id": "019d64bb-19d6-763b-bf8b-f9876b02e7ce",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f9876b02e7ce.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJM0ohrOtmXIYRYyRfkw35ykw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "ec_753b028bc94e81b82ad9553e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "12777 I-10, San Antonio, TX 78230, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-4a82-7041-be14-f3d93d62dcc1.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of an H-E-B grocery store with bright red, green, and blue sections.",
        "public_id": "019d64c5-4a82-7041-be14-f3d93d62dcc1",
        "storage_key": "property/5637285756272640/019d64c5-4a82-7041-be14-f3d93d62dcc1.webp",
        "width": 1630,
        "height": 900
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/san-antonio/de-zavala-h-e-b-395?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=7790376288219946476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "29.56206",
      "poi_longitude": "-98.588102",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-558-3981",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-4d00bd416192.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d64bb-19c4-767d-b643-4d00bd416192",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-4d00bd416192.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNQBxrd5mXIYR7N35ffX5HGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_9bd066ea37581ac32a6a3da6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "15607 Chase Hill Blvd, San Antonio, TX 78256, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-cd66-712a-84c0-a3307b1bfb0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-cd66-712a-84c0-a3307b1bfb0f",
        "storage_key": "property/5637285756272640/019f1515-cd66-712a-84c0-a3307b1bfb0f.webp",
        "width": 1280,
        "height": 861
      },
      "poi_business_url": "https://www.cvs.com/store-locator/san-antonio-tx-pharmacies/15607-chase-hill-blvd-san-antonio-tx-78256/storeid=2391?WT.mc_id=LS_GOOGLE_FS_2391",
      "poi_directions_map_url": "https://maps.google.com/?cid=16659358820013641428&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "29.5894108",
      "poi_longitude": "-98.6244427",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 210-877-8353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv2ZqQHpmXIYR1A6v7JTuMec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_ad278f8f7d744fac7404c9fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "13619 Babcock Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-d0d2-76ae-9c02-74c5216a0679.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-d0d2-76ae-9c02-74c5216a0679",
        "storage_key": "property/5637285756272640/019f1515-d0d2-76ae-9c02-74c5216a0679.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-13619+babcock+rd-san+antonio-tx-78249/id=11520",
      "poi_directions_map_url": "https://maps.google.com/?cid=15353987405855173596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.5726896",
      "poi_longitude": "-98.6321962",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-424-3617",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4sQ5ENmXIYR3KvRWzJSFNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_5481f9f6a07d0e1c83983269",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "6402 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Convenience store and gas station offering coffee, cold beverages, and quick bites.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-d6b8-775a-972d-6571b1c4794e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-d6b8-775a-972d-6571b1c4794e",
        "storage_key": "property/5637285756272640/019f1515-d6b8-775a-972d-6571b1c4794e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/san-antonio/6402-de-zavala-rd/2741846?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3712629011972909393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "29.5621109",
      "poi_longitude": "-98.6140032",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-561-6012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c6-2296-75da-baeb-66aadcda4543.webp",
      "poi_map_icon_media": {
        "alt_text": "Storefront icon",
        "public_id": "019d64c6-2296-75da-baeb-66aadcda4543",
        "storage_key": "property/5637285756272640/019d64c6-2296-75da-baeb-66aadcda4543.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ-WYC5_hmXIYRUWl0gWrohTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_25872a593d0f54b8c280cc87",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "5203 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-4838-703b-a97c-5667dd9d64df.webp",
      "poi_featured_image_media": {
        "alt_text": "7-Eleven convenience store exterior and signage",
        "public_id": "019d64c5-4838-703b-a97c-5667dd9d64df",
        "storage_key": "property/5637285756272640/019d64c5-4838-703b-a97c-5667dd9d64df.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/san-antonio/5203-de-zavala-rd-36255?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13079220764859972201&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "29.5651411",
      "poi_longitude": "-98.5867183",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-558-0459",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c6-2296-75da-baeb-66aadcda4543.webp",
      "poi_map_icon_media": {
        "alt_text": "Storefront icon",
        "public_id": "019d64c6-2296-75da-baeb-66aadcda4543",
        "storage_key": "property/5637285756272640/019d64c6-2296-75da-baeb-66aadcda4543.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJLQn5uttmXIYRaTpkLP25grU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_cdde63f95f4bf0fc1dabcde8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "The Shops at La Cantera",
      "poi_type": "Shopping & Retail",
      "poi_address": "15900 La Cantera Pkwy Ste 6698, San Antonio, TX 78256, USA",
      "poi_short_description": "Upscale shopping center along an outdoor mall-style walkway with a wide variety of restaurants, shops and food options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64ba-4935-7782-9d1f-201284ad027f.webp",
      "poi_featured_image_media": {
        "alt_text": "The Cheesecake Factory restaurant entrance with signage.",
        "public_id": "019d64ba-4935-7782-9d1f-201284ad027f",
        "storage_key": "property/5637285756272640/019d64ba-4935-7782-9d1f-201284ad027f.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.theshopsatlacantera.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11016393100736632124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-shops-at-la-cantera",
      "poi_latitude": "29.5922066",
      "poi_longitude": "-98.6153483",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-582-6255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f9876b02e7ce.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smile",
        "public_id": "019d64bb-19d6-763b-bf8b-f9876b02e7ce",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f9876b02e7ce.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4RQtcodmXIYRPJV4YygX4pg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_5f37e9f494ff6f399c6e18d9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Locke Hill Elementary School",
      "poi_type": "Education",
      "poi_address": "5050 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-557e-71e0-afa6-0b9cf40aa4f5.webp",
      "poi_featured_image_media": {
        "alt_text": "Sign for Locke Hill Elementary School welcoming students back for the first day of school.",
        "public_id": "019d64c5-557e-71e0-afa6-0b9cf40aa4f5",
        "storage_key": "property/5637285756272640/019d64c5-557e-71e0-afa6-0b9cf40aa4f5.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://nisd.net/lockehill/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16274759249029431083&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "locke-hill-elementary-school",
      "poi_latitude": "29.5650914",
      "poi_longitude": "-98.5835597",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-397-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d64bb-1a00-752d-ae9c-baa2e680bdc6",
        "storage_key": "property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIRKGftpmXIYRK_9mQ0-P2-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_6206c4c09f58fb1752a46812",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Clark High School",
      "poi_type": "Education",
      "poi_address": "5150 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-551a-752d-91c5-bba479e6d173.webp",
      "poi_featured_image_media": {
        "alt_text": "A choir performs on stage in an auditorium.",
        "public_id": "019d64c5-551a-752d-91c5-bba479e6d173",
        "storage_key": "property/5637285756272640/019d64c5-551a-752d-91c5-bba479e6d173.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.nisd.net/clark/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14603513433088113591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clark-high-school",
      "poi_latitude": "29.5654954",
      "poi_longitude": "-98.5809493",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-397-5150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d64bb-1a00-752d-ae9c-baa2e680bdc6",
        "storage_key": "property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkd9S6dFmXIYRt7vcOxgaqso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_e1f9024b457124645adf5043",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Ed Rawlinson Middle School",
      "poi_type": "Education",
      "poi_address": "14100 Vance Jackson Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-617f-731e-a94a-d8fed7062000.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a large building with a curved roof and a parking lot full of cars.",
        "public_id": "019d64c5-617f-731e-a94a-d8fed7062000",
        "storage_key": "property/5637285756272640/019d64c5-617f-731e-a94a-d8fed7062000.webp",
        "width": 605,
        "height": 275
      },
      "poi_business_url": "http://nisd.net/rawlinson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5568376810541277472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ed-rawlinson-middle-school",
      "poi_latitude": "29.5764124",
      "poi_longitude": "-98.5845772",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-397-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d64bb-1a00-752d-ae9c-baa2e680bdc6",
        "storage_key": "property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzVNQQ8ZmXIYRIOHV5zTZRk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_30b52ca329b25795874d694f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Louis D. Brandeis High School",
      "poi_type": "Education",
      "poi_address": "13011 Kyle Seale Pkwy, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-dbc3-7059-93b2-0cbd920fba48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-dbc3-7059-93b2-0cbd920fba48",
        "storage_key": "property/5637285756272640/019f1515-dbc3-7059-93b2-0cbd920fba48.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nisd.net/brandeis/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17189997156526165647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "louis-d-brandeis-high-school",
      "poi_latitude": "29.5654611",
      "poi_longitude": "-98.6463289",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 210-397-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d64bb-1a00-752d-ae9c-baa2e680bdc6",
        "storage_key": "property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlX7_2TBmXIYRj463XFYjj-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_0c7475bc90d16edbf4efdb55",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Carl Wanke Elementary School",
      "poi_type": "Education",
      "poi_address": "10419 Old Prue Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-d844-7054-9f5c-aa75e757b03f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-d844-7054-9f5c-aa75e757b03f",
        "storage_key": "property/5637285756272640/019f1515-d844-7054-9f5c-aa75e757b03f.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://nisd.net/wanke/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8086436231901082476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carl-wanke-elementary-school",
      "poi_latitude": "29.5419257",
      "poi_longitude": "-98.6524003",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-397-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d64bb-1a00-752d-ae9c-baa2e680bdc6",
        "storage_key": "property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1-mxgdBnXIYRbPNPvejKOHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_a9abec9f0f6d204c9ac6c815",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "F. R. Scobee Elementary School",
      "poi_type": "Education",
      "poi_address": "11223 Cedar Park, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://nisd.net/scobee/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9784490009122907083&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "f-r-scobee-elementary-school",
      "poi_latitude": "29.5544101",
      "poi_longitude": "-98.642293",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-397-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d64bb-1a00-752d-ae9c-baa2e680bdc6",
        "storage_key": "property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgbCkuTRmXIYRyyMhptJ9yYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_50b034e17e4b34d855fa7454",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Murray E. Boone Elementary School",
      "poi_type": "Education",
      "poi_address": "6614 Spring Time Dr, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://nisd.net/boone/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5965907268578370101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "murray-e-boone-elementary-school",
      "poi_latitude": "29.5515615",
      "poi_longitude": "-98.6180423",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-397-1450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d64bb-1a00-752d-ae9c-baa2e680bdc6",
        "storage_key": "property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc4Y2RqpnXIYRNeKIUg0py1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_83ca03beafdedb8c5e7064ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Peggy Carnahan Elementary School",
      "poi_type": "Education",
      "poi_address": "6839 Babcock Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-636a-750b-99b8-c9feccb69946.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Peggy Carnahan Elementary School with purple flowers in the foreground.",
        "public_id": "019d64c5-636a-750b-99b8-c9feccb69946",
        "storage_key": "property/5637285756272640/019d64c5-636a-750b-99b8-c9feccb69946.webp",
        "width": 605,
        "height": 275
      },
      "poi_business_url": "https://nisd.net/carnahan/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15989121014701719696&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peggy-carnahan-elementary-school",
      "poi_latitude": "29.5582574",
      "poi_longitude": "-98.623155",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-397-5850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d64bb-1a00-752d-ae9c-baa2e680bdc6",
        "storage_key": "property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkVA-6_9mXIYRkIAHUNnE5N0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_4b49d5cf9875e51d8bb4f1c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Summerlin Childcare & Learning Center",
      "poi_type": "Education",
      "poi_address": "6387 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Relaxed child-care center featuring educational programs and friendly staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-696b-70aa-9258-24af162cd1e6.webp",
      "poi_featured_image_media": {
        "alt_text": "Classroom with tables, chairs, and educational decorations",
        "public_id": "019d64c5-696b-70aa-9258-24af162cd1e6",
        "storage_key": "property/5637285756272640/019d64c5-696b-70aa-9258-24af162cd1e6.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "https://www.summerlindaycare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10713641541358944938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "summerlin-childcare--learning-center",
      "poi_latitude": "29.5635407",
      "poi_longitude": "-98.611924",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-641-7337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d64bb-1a00-752d-ae9c-baa2e680bdc6",
        "storage_key": "property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG_3vFvlmXIYRqoKR8zeArpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_2227e87ac3b73042c5f4e8dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Mi Casa Child Center",
      "poi_type": "Education",
      "poi_address": "4820 Brandeis St, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-e33c-736a-83be-5c4705d200d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-e33c-736a-83be-5c4705d200d7",
        "storage_key": "property/5637285756272640/019f1515-e33c-736a-83be-5c4705d200d7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.micasachildcenters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5076281592770848220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mi-casa-child-center",
      "poi_latitude": "29.5680672",
      "poi_longitude": "-98.5805456",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 726-227-1272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d64bb-1a00-752d-ae9c-baa2e680bdc6",
        "storage_key": "property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn4VWzNFmXIYR3OX1nDaTckY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_552988240418c8eb3b200814",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Santikos Palladium",
      "poi_type": "Entertainment",
      "poi_address": "17703 W Interstate 10 Frontage Rd, San Antonio, TX 78257, USA",
      "poi_short_description": "Upscale movie theater with a full food & drink menu, plus table seating & wait service.",
      "poi_long_description": "Upscale movie theater with a full food & drink menu, plus table seating & wait service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-6dbf-74ed-9c1e-d05d1a92a287.webp",
      "poi_featured_image_media": {
        "alt_text": "The Palladium building exterior with grand columns and signage.",
        "public_id": "019d64c5-6dbf-74ed-9c1e-d05d1a92a287",
        "storage_key": "property/5637285756272640/019d64c5-6dbf-74ed-9c1e-d05d1a92a287.webp",
        "width": 2048,
        "height": 1152
      },
      "poi_business_url": "https://www.santikos.com/san-antonio/palladium/theater-info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8534017591422902188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santikos-palladium",
      "poi_latitude": "29.6085339",
      "poi_longitude": "-98.5992852",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 877-691-0734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c6-228a-7241-9eae-55126f376dcf.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic video icon",
        "public_id": "019d64c6-228a-7241-9eae-55126f376dcf",
        "storage_key": "property/5637285756272640/019d64c6-228a-7241-9eae-55126f376dcf.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ZDq_iNkXIYRrF-yw8jrbnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_ac8072ba9d10c17785a80321",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Topgolf San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "5539 N Loop 1604 W, San Antonio, TX 78249, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64ba-2ac5-7617-a5da-c146fd697aff.webp",
      "poi_featured_image_media": {
        "alt_text": "Event space with tables set for dining, overlooking a golf course.",
        "public_id": "019d64ba-2ac5-7617-a5da-c146fd697aff",
        "storage_key": "property/5637285756272640/019d64ba-2ac5-7617-a5da-c146fd697aff.webp",
        "width": 800,
        "height": 525
      },
      "poi_business_url": "https://topgolf.com/us/san-antonio/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18114592869921636103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-san-antonio",
      "poi_latitude": "29.5940894",
      "poi_longitude": "-98.5950414",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-202-2694",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
      "poi_map_icon_media": {
        "alt_text": "A graphic icon of a fork and knife.",
        "public_id": "019d64bb-19d6-763b-bf8b-f54454596b4a",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVZ8Xo5hmXIYRB7-Abj32Y_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_e9e764826db85dfda25301f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Andretti Indoor Karting & Games San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "5527 N Loop 1604 W, San Antonio, TX 78249, USA",
      "poi_short_description": "Indoor amusement hub with arcade games, a go-karting track & bowling, plus a casual restaurant.",
      "poi_long_description": "Indoor amusement hub with arcade games, a go-karting track & bowling, plus a casual restaurant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-6e11-73b5-b3a4-136cfd346073.webp",
      "poi_featured_image_media": {
        "alt_text": "Andretti Indoor Karting & Games building exterior with modern green and gray architecture.",
        "public_id": "019d64c5-6e11-73b5-b3a4-136cfd346073",
        "storage_key": "property/5637285756272640/019d64c5-6e11-73b5-b3a4-136cfd346073.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://andrettikarting.com/sanantonio/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5476718655430571720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andretti-indoor-karting--games-san-antonio",
      "poi_latitude": "29.5930823",
      "poi_longitude": "-98.5941651",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-469-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ04MIGY5nXIYRyLaxp5k2AUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_fde530f2087d752f0818ef94",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "PINSTACK",
      "poi_type": "Entertainment",
      "poi_address": "19238 I-10, San Antonio, TX 78257, USA",
      "poi_short_description": "Clean entertainment destination featuring state-of-the-art bowling lanes and an elevated game room.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-869c-717b-a895-196a873f68f6.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior view of a bowling alley with lanes, seating, and large screens.",
        "public_id": "019d64c5-869c-717b-a895-196a873f68f6",
        "storage_key": "property/5637285756272640/019d64c5-869c-717b-a895-196a873f68f6.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://pinstackbowl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13207843838358140137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinstack",
      "poi_latitude": "29.6220783",
      "poi_longitude": "-98.606792",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-267-9902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlfC9pbhlXIYR6TQrKv6vS7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "ec_265d1e63fe16dfb1a6b067ff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Chicken N Pickle - San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "5215 UTSA Boulevard, San Antonio, TX 78249, USA",
      "poi_short_description": "Relaxed spot for fried chicken, waffles, burgers, tacos and other American-style dishes featuring local ingredients.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64ba-3ec4-72de-b111-5b3444d81023.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d64ba-3ec4-72de-b111-5b3444d81023",
        "storage_key": "property/5637285756272640/019d64ba-3ec4-72de-b111-5b3444d81023.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/san-antonio/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4563753068854166721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-n-pickle---san-antonio",
      "poi_latitude": "29.5791894",
      "poi_longitude": "-98.5899423",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-874-2120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
      "poi_map_icon_media": {
        "alt_text": "A graphic icon of a fork and knife.",
        "public_id": "019d64bb-19d6-763b-bf8b-f54454596b4a",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ59lWzitnXIYRwcSmfzy1VT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_17cbe0c0bfa9102e4519aa82",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Six Flags Fiesta Texas",
      "poi_type": "Entertainment",
      "poi_address": "San Antonio, TX 78257, USA",
      "poi_short_description": "Part of an amusement park chain with roller coasters, rides, live shows, a water park, food & beer.",
      "poi_long_description": "Part of an amusement park chain with roller coasters, rides, live shows, a water park, food & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1513-b88f-70a8-9f3b-d7964f25d391.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-b88f-70a8-9f3b-d7964f25d391",
        "storage_key": "property/5637285756272640/019f1513-b88f-70a8-9f3b-d7964f25d391.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/fiestatexas?utm_source=googlebusinessprofile&utm_medium=organic&utm_campaign=Google+Business+Profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=2548967654066146973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "six-flags-fiesta-texas",
      "poi_latitude": "29.5993818",
      "poi_longitude": "-98.6088838",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-697-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN55XmxZlXIYRnc6SjJPAXyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_5ae3b724ce47625fe726f63c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "The Escape Game San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "5822 Worth Pkwy Suite 101, San Antonio, TX 78257, USA",
      "poi_short_description": "Themed rooms for puzzle-solving team games and clues to find your way out.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-e38a-729b-a2cf-d73b382a97d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-e38a-729b-a2cf-d73b382a97d0",
        "storage_key": "property/5637285756272640/019f1515-e38a-729b-a2cf-d73b382a97d0.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://theescapegame.com/san-antonio/?utm_source=google&utm_medium=organic&utm_campaign=gbp&utm_id=san-antonio",
      "poi_directions_map_url": "https://maps.google.com/?cid=9670956354561004001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-escape-game-san-antonio",
      "poi_latitude": "29.6112979",
      "poi_longitude": "-98.5988885",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 726-227-3834",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9xofKrhlXIYR4VHqx5AjNoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_69d12a6528f1f07598f7c328",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Sandbox VR",
      "poi_type": "Entertainment",
      "poi_address": "5822 Worth Pkwy Ste 102, San Antonio, TX 78257, USA",
      "poi_short_description": "Family-friendly chain offering immersive virtual reality experiences and birthday parties.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-e906-7161-834d-f631eb6356a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-e906-7161-834d-f631eb6356a6",
        "storage_key": "property/5637285756272640/019f1515-e906-7161-834d-f631eb6356a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sandboxvr.com/sanantonio",
      "poi_directions_map_url": "https://maps.google.com/?cid=2067830103554047032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sandbox-vr",
      "poi_latitude": "29.6112366",
      "poi_longitude": "-98.5988201",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 830-239-8229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJWETU6VlXIYROLwy-oVoshw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_57170d5b7f912607e2e5b6c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "iFLY Indoor Skydiving - San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "15915 I-10, San Antonio, TX 78249, USA",
      "poi_short_description": "Indoor skydiving facility with a wind tunnel where experienced instructors offer training and guidance.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-e330-711a-81e1-797280ce1551.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-e330-711a-81e1-797280ce1551",
        "storage_key": "property/5637285756272640/019f1515-e330-711a-81e1-797280ce1551.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.iflyworld.com/san-antonio?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8097754445672492456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ifly-indoor-skydiving---san-antonio",
      "poi_latitude": "29.592967",
      "poi_longitude": "-98.597387",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-762-4359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy2iT5K56XIYRqC2mvMMAYXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_1bbf7355ea712ff48a2e98cf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Stone Werks Big Rock Grille, The Rim",
      "poi_type": "Entertainment",
      "poi_address": "5807 Worth Pkwy, San Antonio, TX 78257, USA",
      "poi_short_description": "Part of a local chain serving American fare in a contemporary space, with a full bar, TVs & a patio.",
      "poi_long_description": "Part of a local chain serving American fare in a contemporary space, with a full bar, TVs & a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-e895-77c6-8abf-965083d807a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-e895-77c6-8abf-965083d807a2",
        "storage_key": "property/5637285756272640/019f1515-e895-77c6-8abf-965083d807a2.webp",
        "width": 1280,
        "height": 1011
      },
      "poi_business_url": "https://www.stonewerks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5743976445433820042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stone-werks-big-rock-grille-the-rim",
      "poi_latitude": "29.6132639",
      "poi_longitude": "-98.5990191",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-558-9898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
      "poi_map_icon_media": {
        "alt_text": "A graphic icon of a fork and knife.",
        "public_id": "019d64bb-19d6-763b-bf8b-f54454596b4a",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzl_2CJkXIYRijNL7CS0tk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_6ff859ce517ac73990c7cb31",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Methodist ER De Zavala Rd.",
      "poi_type": "Health and Wellness",
      "poi_address": "12805 I-10, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-e57a-76e5-b252-d74a966b2ae2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-e57a-76e5-b252-d74a966b2ae2",
        "storage_key": "property/5637285756272640/019f1515-e57a-76e5-b252-d74a966b2ae2.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.sahealth.com/locations/methodist-er-de-zavala-rd?utm__campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12888212266027676197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "methodist-er-de-zavala-rd",
      "poi_latitude": "29.5638716",
      "poi_longitude": "-98.5900842",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-575-9805",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJufSdC9BnXIYRJXJpcsUg3LI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_d1852d72ca738207a3472415",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - De Zavala",
      "poi_type": "Health and Wellness",
      "poi_address": "12840 I-10 Suite 101, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-e83d-709e-a74c-a9bcb6fca871.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-e83d-709e-a74c-a9bcb6fca871",
        "storage_key": "property/5637285756272640/019f1515-e83d-709e-a74c-a9bcb6fca871.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.carenow.com/locations/san-antonio/de-zavala?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12982338239398773489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---de-zavala",
      "poi_latitude": "29.5665235",
      "poi_longitude": "-98.5931367",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-817-8490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp5ZGKUdnXIYR8YJVadiHKrQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_1d89670f8dfbe19543320935",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "UT Health De Zavala",
      "poi_type": "Health and Wellness",
      "poi_address": "4306 De Zavala Rd Bldg 1, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-ee88-71f9-8326-da4b48e634d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-ee88-71f9-8326-da4b48e634d6",
        "storage_key": "property/5637285756272640/019f1515-ee88-71f9-8326-da4b48e634d6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.uthscsa.edu/patient-care/physicians/location/UT-Health-De-Zavala?utm_source=google&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=16169904526759849623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ut-health-de-zavala",
      "poi_latitude": "29.5740099",
      "poi_longitude": "-98.5681099",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-450-6720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c5-72a5-b6aa-a28603693059.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d64bb-19c5-72a5-b6aa-a28603693059",
        "storage_key": "property/5637285756272640/019d64bb-19c5-72a5-b6aa-a28603693059.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-6yFMXJhXIYRl26AyX4KZ-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_b808f3b2bd5058163bf3010e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "13619 Babcock Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-d0d2-76ae-9c02-74c5216a0679.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-d0d2-76ae-9c02-74c5216a0679",
        "storage_key": "property/5637285756272640/019f1515-d0d2-76ae-9c02-74c5216a0679.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-13619+babcock+rd-san+antonio-tx-78249/id=11520",
      "poi_directions_map_url": "https://maps.google.com/?cid=15353987405855173596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.5726896",
      "poi_longitude": "-98.6321962",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-424-3617",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4sQ5ENmXIYR3KvRWzJSFNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_f9fa7307180f780dae7644fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "4100 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-f84e-72ea-8927-c63031370fa3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-f84e-72ea-8927-c63031370fa3",
        "storage_key": "property/5637285756272640/019f1515-f84e-72ea-8927-c63031370fa3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/san-antonio-tx-pharmacies/4100-de-zavala-rd-at-the-corner-of-lockhill-selma-road-san-antonio-tx-78249/storeid=8386?WT.mc_id=LS_GOOGLE_FS_8386",
      "poi_directions_map_url": "https://maps.google.com/?cid=16358937667929580045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "29.576199",
      "poi_longitude": "-98.5648381",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-492-9741",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH1buOEthXIYRDSKztyKfBuM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_3d37b738d878f900f29f5061",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5555 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-9002-7375-ac00-5df5416e4457.webp",
      "poi_featured_image_media": {
        "alt_text": "Pharmacy counter with shelves of medications in the background",
        "public_id": "019d64c5-9002-7375-ac00-5df5416e4457",
        "storage_key": "property/5637285756272640/019d64c5-9002-7375-ac00-5df5416e4457.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/2599-san-antonio-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16753586369373158085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "29.5644288",
      "poi_longitude": "-98.5959705",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-558-4330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c6-2299-77d9-968c-78349d7c67a3.webp",
      "poi_map_icon_media": {
        "alt_text": "Mortar and pestle icon",
        "public_id": "019d64c6-2299-77d9-968c-78349d7c67a3",
        "storage_key": "property/5637285756272640/019d64c6-2299-77d9-968c-78349d7c67a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk-cSSOdmXIYRxTpQ5AmygOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_560f21927c18963a5d944233",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Move Fit Live",
      "poi_type": "Health and Wellness",
      "poi_address": "5999 De Zavala Rd #130, San Antonio, TX 78249, USA",
      "poi_short_description": "Down-to-earth fitness center, featuring numerous classes and a weight room, as well as personal training and group workouts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-f5dd-76ba-9c34-88ddb2ef514a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-f5dd-76ba-9c34-88ddb2ef514a",
        "storage_key": "property/5637285756272640/019f1515-f5dd-76ba-9c34-88ddb2ef514a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.movefitlive.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16574447720999041271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "move-fit-live",
      "poi_latitude": "29.5640864",
      "poi_longitude": "-98.6006792",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-558-6683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaxawauRmXIYR9zhuFmNEBOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_a502bf66afbb4938c6d1edd4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Pyramid Physical Therapy & Pilates - San Antonio",
      "poi_type": "Health and Wellness",
      "poi_address": "4939 De Zavala Rd Ste 103, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-f4b4-7209-8c9d-9ba849da9476.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-f4b4-7209-8c9d-9ba849da9476",
        "storage_key": "property/5637285756272640/019f1515-f4b4-7209-8c9d-9ba849da9476.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://pyramidpt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3328700117457682219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pyramid-physical-therapy--pilates---san-antonio",
      "poi_latitude": "29.5685208",
      "poi_longitude": "-98.5788558",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-616-0629",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLy4NEPlmXIYRK7_d4B7rMS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_3654cd18482066c6888dbe7f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Foundation Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "5999 De Zavala Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-fdc8-72da-8350-1059a19de91a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-fdc8-72da-8350-1059a19de91a",
        "storage_key": "property/5637285756272640/019f1515-fdc8-72da-8350-1059a19de91a.webp",
        "width": 880,
        "height": 880
      },
      "poi_business_url": "https://foundation-yoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12664876266233334469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foundation-yoga",
      "poi_latitude": "29.5640586",
      "poi_longitude": "-98.600664",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-367-8780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d64bb-1a00-752d-ae9c-baa2e680bdc6",
        "storage_key": "property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyMSy5VnXIYRxQod3dytwq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_a4f8cb32384185ade34fc0fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Gorrell Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "San Antonio, TX 78249, USA",
      "poi_short_description": "Kid-friendly, wooded outdoor space featuring picnic tables, a playground and trail walks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1516-1464-7236-b90e-5841657132e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-1464-7236-b90e-5841657132e5",
        "storage_key": "property/5637285756272640/019f1516-1464-7236-b90e-5841657132e5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2641/Gorrell-Park?Park=85&Facility=",
      "poi_directions_map_url": "https://maps.google.com/?cid=12748726381435388656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gorrell-park",
      "poi_latitude": "29.5675272",
      "poi_longitude": "-98.5768874",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d64bb-19d6-763b-bf8b-f00fff1ba2d4",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy0wKR-lnXIYR8IIbKBmT7LA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9d59ec9d5e9e12f2c0a78815",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Fox Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6518 W Hausman Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Deer & other local wildlife can frequently be seen at this city park with walking/cycling trails.",
      "poi_long_description": "Deer & other local wildlife can frequently be seen at this city park with walking/cycling trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1516-038f-709a-a127-faf0a57b11c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-038f-709a-a127-faf0a57b11c9",
        "storage_key": "property/5637285756272640/019f1516-038f-709a-a127-faf0a57b11c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sa.gov/Directory/Departments/Parks/Parks-Facilities/Parks/Directory/Fox-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1857581849663715813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fox-park",
      "poi_latitude": "29.5716827",
      "poi_longitude": "-98.6182997",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-207-8480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d64bb-19d6-763b-bf8b-f00fff1ba2d4",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgyfTEVlmXIYR5Tlrstl0xxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f4ccf8a4aabeaefd0f374a41",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Bamberger Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12401 Babcock Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "This tree-filled natural area offers trails for hiking & cycling, plus a playground.",
      "poi_long_description": "This tree-filled natural area offers trails for hiking & cycling, plus a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-a95f-72f8-8ee6-d72d88dd5c7c.webp",
      "poi_featured_image_media": {
        "alt_text": "Outdoor information kiosks with maps and text in a park-like setting.",
        "public_id": "019d64c5-a95f-72f8-8ee6-d72d88dd5c7c",
        "storage_key": "property/5637285756272640/019d64c5-a95f-72f8-8ee6-d72d88dd5c7c.webp",
        "width": 3072,
        "height": 2443
      },
      "poi_business_url": "https://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2435/Bamberger-Nature-Park?Park=11&Facility=",
      "poi_directions_map_url": "https://maps.google.com/?cid=1927048889006278731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bamberger-nature-park",
      "poi_latitude": "29.5610152",
      "poi_longitude": "-98.6291246",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d64bb-19d6-763b-bf8b-f00fff1ba2d4",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJawzKcU5mXIYRS8gHLsFAvho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_a06fb72c62339b7ff93d5d3f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Buddy Calk Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6934 Babcock Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Popular park with paved trails, playgrounds and a creek, plus mountain-bike paths, for wildlife viewing .",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-ab62-778a-9d30-325f6df15537.webp",
      "poi_featured_image_media": {
        "alt_text": "Scenic view of a calm river surrounded by lush green trees and a blue sky with white clouds.",
        "public_id": "019d64c5-ab62-778a-9d30-325f6df15537",
        "storage_key": "property/5637285756272640/019d64c5-ab62-778a-9d30-325f6df15537.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.sanantonio.gov/GreenwayTrails",
      "poi_directions_map_url": "https://maps.google.com/?cid=10203707128741324386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buddy-calk-trailhead",
      "poi_latitude": "29.5568877",
      "poi_longitude": "-98.6267101",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d64bb-19d6-763b-bf8b-f00fff1ba2d4",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwaWphFJmXIYRYma_cJLZmo0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a3c47178be01d438042c3475",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Walker Ranch Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12603 West Ave, San Antonio, TX 78216, USA",
      "poi_short_description": "Grassy, tree-filled park offering walking trails, a big playground & picnic shelter.",
      "poi_long_description": "Grassy, tree-filled park offering walking trails, a big playground & picnic shelter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-de7e-7068-8287-2d620d476cf8.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides and climbing structures in a park-like setting.",
        "public_id": "019d64c5-de7e-7068-8287-2d620d476cf8",
        "storage_key": "property/5637285756272640/019d64c5-de7e-7068-8287-2d620d476cf8.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2467/Walker-Ranch/Park/250",
      "poi_directions_map_url": "https://maps.google.com/?cid=5256102213650417887&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walker-ranch-park",
      "poi_latitude": "29.55616699999999",
      "poi_longitude": "-98.5002317",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 210-207-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d64bb-19d6-763b-bf8b-f00fff1ba2d4",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4RznxTNgXIYR3wjHgx1t8Ug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_924a1150e8570715443be826",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Orsinger Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12230 Huebner Rd, San Antonio, TX 78230, USA",
      "poi_short_description": "Bustling urban park features trails, a playground & picnic pavilion with a rental kitchen facility.",
      "poi_long_description": "Bustling urban park features trails, a playground & picnic pavilion with a rental kitchen facility.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1516-13a8-779d-bcbf-09beb5f71efe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-13a8-779d-bcbf-09beb5f71efe",
        "storage_key": "property/5637285756272640/019f1516-13a8-779d-bcbf-09beb5f71efe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bexar.org/3656/Orsinger-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5268560010445158440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orsinger-park",
      "poi_latitude": "29.5569111",
      "poi_longitude": "-98.5648909",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-335-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d64bb-19d6-763b-bf8b-f00fff1ba2d4",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMcW9RtZgXIYRKHhpXGqvHUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_51370554b081950817b84c0b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Oakwell Trailhead Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "150 Ira Lee Rd, San Antonio, TX 78218, USA",
      "poi_short_description": "Trailhead for a 2.1-mile greenway path for hiking & biking, plus picnic tables by a local artist.",
      "poi_long_description": "Trailhead for a 2.1-mile greenway path for hiking & biking, plus picnic tables by a local artist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1516-0c9c-716f-a619-a597aa5e1f77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-0c9c-716f-a619-a597aa5e1f77",
        "storage_key": "property/5637285756272640/019f1516-0c9c-716f-a619-a597aa5e1f77.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16565093249423972388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oakwell-trailhead-park",
      "poi_latitude": "29.50216319999999",
      "poi_longitude": "-98.4210044",
      "poi_miles_from_property": "14.2 mi",
      "poi_walking_minutes": "5 hours 15 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d64bb-19d6-763b-bf8b-f00fff1ba2d4",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk_85esb0XIYRJBgjc4sI4-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_377d681380e5e20e131b1ec7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Phil Hardberger Park (East)",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13203 Blanco Rd, San Antonio, TX 78216, USA",
      "poi_short_description": "Relaxing, tree-filled, green space featuring a dog park, hiking and biking paths, and playscapes for kids.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-abbf-7004-98b4-c475c1f6b778.webp",
      "poi_featured_image_media": {
        "alt_text": "Large ancient oak tree with sprawling branches and a rustic wooden fence in a park-like setting.",
        "public_id": "019d64c5-abbf-7004-98b4-c475c1f6b778",
        "storage_key": "property/5637285756272640/019d64c5-abbf-7004-98b4-c475c1f6b778.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2638/Phil-Hardberger-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9809679465364909275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phil-hardberger-park-east",
      "poi_latitude": "29.5612034",
      "poi_longitude": "-98.5198315",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-207-3781",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d64bb-19d6-763b-bf8b-f00fff1ba2d4",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNRHSJH9hXIYR2-yE9X_7Iog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_178d3e8feb9c4752efa21b78",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "McAllister Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13102 Jones Maltsberger Rd, San Antonio, TX 78247, USA",
      "poi_short_description": "Natural area with jogging & biking trails, picnic spots, a dog park, playscapes & athletic fields.",
      "poi_long_description": "Natural area with jogging & biking trails, picnic spots, a dog park, playscapes & athletic fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-cc30-77e7-a15d-e99dd7315b3f.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides and climbing structures.",
        "public_id": "019d64c5-cc30-77e7-a15d-e99dd7315b3f",
        "storage_key": "property/5637285756272640/019d64c5-cc30-77e7-a15d-e99dd7315b3f.webp",
        "width": 3024,
        "height": 3024
      },
      "poi_business_url": "http://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2578/McAllister-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1871900702508716191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcallister-park",
      "poi_latitude": "29.563045",
      "poi_longitude": "-98.4542279",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree",
        "public_id": "019d64bb-19d6-763b-bf8b-f00fff1ba2d4",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f00fff1ba2d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJa-WcPyKXIYRnxDWa8VT-hk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_a066b65d158bd064a4fd5e02",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Wingstop",
      "poi_type": "Transportation & Transit",
      "poi_address": "5222 De Zavala Rd Ste 324, San Antonio, TX 78249, USA",
      "poi_short_description": "Casual counter-serve chain serving a variety of chicken wings & sides.",
      "poi_long_description": "Casual counter-serve chain serving a variety of chicken wings & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1516-1070-74da-ad29-f01ba15b353d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-1070-74da-ad29-f01ba15b353d",
        "storage_key": "property/5637285756272640/019f1516-1070-74da-ad29-f01ba15b353d.webp",
        "width": 1152,
        "height": 648
      },
      "poi_business_url": "https://www.wingstop.com/location/wingstop-319-san-antonio-tx-78249/menu?y_source=1_NTUyMDY1OTgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1395565837008575107&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wingstop",
      "poi_latitude": "29.5640353",
      "poi_longitude": "-98.5866727",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-697-9464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
      "poi_map_icon_media": {
        "alt_text": "A graphic icon of a fork and knife.",
        "public_id": "019d64bb-19d6-763b-bf8b-f54454596b4a",
        "storage_key": "property/5637285756272640/019d64bb-19d6-763b-bf8b-f54454596b4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk1B_v9tmXIYRgxqRF7wLXhM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "ec_d4e3493830e0262c0f62ad84",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "De Zavala & Lockhill-Selma",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7901620040781890822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "de-zavala--lockhill-selma",
      "poi_latitude": "29.576343",
      "poi_longitude": "-98.5654555",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9dQkxjZhXIYRBoXpAJAxqG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_f33ec49c9737f16c034801a1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "De Zavala In Front Of 5250 (I-10w)",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1516-17f9-71c4-95b6-dac3c0ccccf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-17f9-71c4-95b6-dac3c0ccccf1",
        "storage_key": "property/5637285756272640/019f1516-17f9-71c4-95b6-dac3c0ccccf1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5936002442402914592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "de-zavala-in-front-of-5250-i-10w",
      "poi_latitude": "29.5635771",
      "poi_longitude": "-98.5892834",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ07XiD9xmXIYRIOFGZcXqYFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_7081c49417e14a125d7cebf4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "VIA Crossroads Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "151 N Crossroads Blvd, Balcones Heights, TX 78201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c6-0417-735d-9198-d8aadba351b4.webp",
      "poi_featured_image_media": {
        "alt_text": "Sidewalk and street view of apartment complex entrance with crosswalk and caution signs.",
        "public_id": "019d64c6-0417-735d-9198-d8aadba351b4",
        "storage_key": "property/5637285756272640/019d64c6-0417-735d-9198-d8aadba351b4.webp",
        "width": 3072,
        "height": 1384
      },
      "poi_business_url": "http://viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14912817806174523366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-crossroads-park--ride",
      "poi_latitude": "29.493575",
      "poi_longitude": "-98.5483679",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-362-2892",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c6-2296-75da-baeb-63e745065588.webp",
      "poi_map_icon_media": {
        "alt_text": "Letter P",
        "public_id": "019d64c6-2296-75da-baeb-63e745065588",
        "storage_key": "property/5637285756272640/019d64c6-2296-75da-baeb-63e745065588.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJNXQTzYRfXIYR5g8ngcj49M4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_1a5da4bcb70186ec5628203b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Ingram Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3215 Northwestern Dr, San Antonio, TX 78238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-ef62-77ac-b860-b1265843e997.webp",
      "poi_featured_image_media": {
        "alt_text": "Outdoor seating area with covered shelter and informational signage.",
        "public_id": "019d64c5-ef62-77ac-b860-b1265843e997",
        "storage_key": "property/5637285756272640/019d64c5-ef62-77ac-b860-b1265843e997.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://www.viainfo.net/transit-centers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15286896482762599812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ingram-transit-center",
      "poi_latitude": "29.4648153",
      "poi_longitude": "-98.6257608",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-521-6773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJryXVZVvZ-4YRhK07jVv3JdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_1acaba661f0b1d4bf8920c4f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "North Star Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7538 San Pedro Ave, San Antonio, TX 78216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-ee25-7449-864b-cef9c74f70d0.webp",
      "poi_featured_image_media": {
        "alt_text": "People waiting at a bus stop with a bus at the platform.",
        "public_id": "019d64c5-ee25-7449-864b-cef9c74f70d0",
        "storage_key": "property/5637285756272640/019d64c5-ee25-7449-864b-cef9c74f70d0.webp",
        "width": 3024,
        "height": 3024
      },
      "poi_business_url": "http://www.viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10414624133700210677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-star-transit-center",
      "poi_latitude": "29.51912",
      "poi_longitude": "-98.49871",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-409-7788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRbAqpAlgXIYR9U9pdngtiJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_c44d0529fcabe64e192a83ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "VIA Stone Oak Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "22139 US-281, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-ce1e-711f-8f6e-c1a2f619d713.webp",
      "poi_featured_image_media": {
        "alt_text": "Empty parking garage with concrete floors and ceiling, yellow bollards, and stairs visible.",
        "public_id": "019d64c5-ce1e-711f-8f6e-c1a2f619d713",
        "storage_key": "property/5637285756272640/019d64c5-ce1e-711f-8f6e-c1a2f619d713.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.viainfo.net/park-ride-commuting/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18423806789292463184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-stone-oak-park--ride",
      "poi_latitude": "29.6480735",
      "poi_longitude": "-98.452267",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 27 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 210-362-2887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c6-2296-75da-baeb-63e745065588.webp",
      "poi_map_icon_media": {
        "alt_text": "Letter P",
        "public_id": "019d64c6-2296-75da-baeb-63e745065588",
        "storage_key": "property/5637285756272640/019d64c6-2296-75da-baeb-63e745065588.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ47WvqEaJXIYRUBQ1TqmCrv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_a58dee56dac11bce982cda94",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Medical Center Transit Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "5330 Medical Dr, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-ddbf-7755-ae66-256f7495bae8.webp",
      "poi_featured_image_media": {
        "alt_text": "Buses at a transit station next to a modern building.",
        "public_id": "019d64c5-ddbf-7755-ae66-256f7495bae8",
        "storage_key": "property/5637285756272640/019d64c5-ddbf-7755-ae66-256f7495bae8.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17748660839738358253&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-center-transit-station",
      "poi_latitude": "29.5076924",
      "poi_longitude": "-98.5896433",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 210-362-2896",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl0GJN_RdXIYR7bl9T__oT_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_cf077fe21bd6eaf16da9658c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Randolph Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "9400 I-35, San Antonio, TX 78233, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1516-1e3d-74dc-b699-91c8bbbad08f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-1e3d-74dc-b699-91c8bbbad08f",
        "storage_key": "property/5637285756272640/019f1516-1e3d-74dc-b699-91c8bbbad08f.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12602308921134006725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "randolph-park-and-ride",
      "poi_latitude": "29.5244671",
      "poi_longitude": "-98.3923536",
      "poi_miles_from_property": "16.9 mi",
      "poi_walking_minutes": "6 hours 18 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c6-2296-75da-baeb-63e745065588.webp",
      "poi_map_icon_media": {
        "alt_text": "Letter P",
        "public_id": "019d64c6-2296-75da-baeb-63e745065588",
        "storage_key": "property/5637285756272640/019d64c6-2296-75da-baeb-63e745065588.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJMct5BLKNXIYRxcHtoTFl5K4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_c7b16500cb26b3efea809157",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "San Antonio International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "9800 Airport Blvd, San Antonio, TX 78216, USA",
      "poi_short_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_long_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-cdaf-759c-abdd-cbb20255ab64.webp",
      "poi_featured_image_media": {
        "alt_text": "Circular sculpture made of stacked suitcases in an airport terminal.",
        "public_id": "019d64c5-cdaf-759c-abdd-cbb20255ab64",
        "storage_key": "property/5637285756272640/019d64c5-cdaf-759c-abdd-cbb20255ab64.webp",
        "width": 1512,
        "height": 2016
      },
      "poi_business_url": "https://www.flysanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18041828760938859602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-international-airport",
      "poi_latitude": "29.5331282",
      "poi_longitude": "-98.4705422",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-207-3433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c6-2287-75b3-a00a-7fc956fb5fc5.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019d64c6-2287-75b3-a00a-7fc956fb5fc5",
        "storage_key": "property/5637285756272640/019d64c6-2287-75b3-a00a-7fc956fb5fc5.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4DLsbuKXIYRUswvGqtzYfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_5b533a0433c3805e8dc665ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Valero",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Valero Way, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64ba-ef02-75ff-b5fd-cdfb5cf82f04.webp",
      "poi_featured_image_media": {
        "alt_text": "Valero Energy Corporation monument sign with text 'ONE VALERO WAY'",
        "public_id": "019d64ba-ef02-75ff-b5fd-cdfb5cf82f04",
        "storage_key": "property/5637285756272640/019d64ba-ef02-75ff-b5fd-cdfb5cf82f04.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "http://www.valero.com/ourbusiness/ourlocations/offices/pages/valerocorporateheadquarters.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16201185604516536043&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valero",
      "poi_latitude": "29.5869869",
      "poi_longitude": "-98.6070957",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-345-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv1eqHI5mXIYR615hQXgs1uA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_7dac0d24a0a8048256f75fb6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "The University of Texas at San Antonio",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Physical Education Building, 1 UTSA Circle, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64ba-4ccf-75bc-8b8a-c9c1fefcc964.webp",
      "poi_featured_image_media": {
        "alt_text": "People walking through a courtyard with modern buildings and trees.",
        "public_id": "019d64ba-4ccf-75bc-8b8a-c9c1fefcc964",
        "storage_key": "property/5637285756272640/019d64ba-4ccf-75bc-8b8a-c9c1fefcc964.webp",
        "width": 2048,
        "height": 1334
      },
      "poi_business_url": "https://www.utsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2658632929587635980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-texas-at-san-antonio",
      "poi_latitude": "29.5830733",
      "poi_longitude": "-98.6198779",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-458-4011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d64bb-1a00-752d-ae9c-baa2e680bdc6",
        "storage_key": "property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3X9l1n1mXIYRDCc6PJBc5SQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_3372dd96289919de1eb0ba0e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "UT Health De Zavala",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4306 De Zavala Rd Bldg 1, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1515-ee88-71f9-8326-da4b48e634d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-ee88-71f9-8326-da4b48e634d6",
        "storage_key": "property/5637285756272640/019f1515-ee88-71f9-8326-da4b48e634d6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.uthscsa.edu/patient-care/physicians/location/UT-Health-De-Zavala?utm_source=google&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=16169904526759849623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ut-health-de-zavala",
      "poi_latitude": "29.5740099",
      "poi_longitude": "-98.5681099",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-450-6720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c5-72a5-b6aa-a28603693059.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d64bb-19c5-72a5-b6aa-a28603693059",
        "storage_key": "property/5637285756272640/019d64bb-19c5-72a5-b6aa-a28603693059.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-6yFMXJhXIYRl26AyX4KZ-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_6930071e518e8aa34655aff1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Methodist Hospital Stone Oak",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1139 E Sonterra Blvd, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c5-87ce-75ae-a475-d54e965ec9e6.webp",
      "poi_featured_image_media": {
        "alt_text": "Methodist Stone Oak Hospital exterior with V. Benson Pavilion and lush landscaping under a blue sky.",
        "public_id": "019d64c5-87ce-75ae-a475-d54e965ec9e6",
        "storage_key": "property/5637285756272640/019d64c5-87ce-75ae-a475-d54e965ec9e6.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.sahealth.com/locations/methodist-hospital-stone-oak?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7066658014942627455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "methodist-hospital-stone-oak",
      "poi_latitude": "29.6162229",
      "poi_longitude": "-98.4743864",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 210-638-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c5-72a5-b6aa-a28603693059.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d64bb-19c5-72a5-b6aa-a28603693059",
        "storage_key": "property/5637285756272640/019d64bb-19c5-72a5-b6aa-a28603693059.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4q-ivmJXIYRf4bSGQbQEWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_343a637b51ada01cbdf22146",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "North Central Baptist Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "520 Madison Oak Dr, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64c6-02cc-73d0-aa81-3927ffa7a67f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d64c6-02cc-73d0-aa81-3927ffa7a67f",
        "storage_key": "property/5637285756272640/019d64c6-02cc-73d0-aa81-3927ffa7a67f.webp",
        "width": 1280,
        "height": 865
      },
      "poi_business_url": "https://www.baptisthealthsystem.com/locations/detail/north-central-baptist-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=9906410289780053303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-central-baptist-hospital",
      "poi_latitude": "29.6204476",
      "poi_longitude": "-98.4908558",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-297-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c5-72a5-b6aa-a28603693059.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d64bb-19c5-72a5-b6aa-a28603693059",
        "storage_key": "property/5637285756272640/019d64bb-19c5-72a5-b6aa-a28603693059.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwCXMoxjXIYRN1WdEayjeok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_74d9319ba01ab3db2619e35f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Northside Independent School District Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5900 Evers Rd, San Antonio, TX 78238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://nisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=592429851399403552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northside-independent-school-district-administration-building",
      "poi_latitude": "29.4908341",
      "poi_longitude": "-98.6012233",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 210-397-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d64bb-1a00-752d-ae9c-baa2e680bdc6",
        "storage_key": "property/5637285756272640/019d64bb-1a00-752d-ae9c-baa2e680bdc6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx7e68JZdXIYRILj_ns-7OAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_1890d9ce56f62dec3da1bd3d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Southwest Research Institute",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6220 Culebra Rd, San Antonio, TX 78238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1516-221d-744d-9088-8a90fb61f176.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-221d-744d-9088-8a90fb61f176",
        "storage_key": "property/5637285756272640/019f1516-221d-744d-9088-8a90fb61f176.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.swri.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=181758218444497686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southwest-research-institute",
      "poi_latitude": "29.4521256",
      "poi_longitude": "-98.6102811",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 6 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 210-684-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_8dKB1pcXIYRFmNk_SK8hQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_182dcbfbcc62c21cc4312f7a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "H-E-B Corporate Office Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "646 S Flores St, San Antonio, TX 78204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1516-2471-75fe-b754-39ab330c3080.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-2471-75fe-b754-39ab330c3080",
        "storage_key": "property/5637285756272640/019f1516-2471-75fe-b754-39ab330c3080.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/static-page/heb-corporate-office-hq",
      "poi_directions_map_url": "https://maps.google.com/?cid=10485037645668446608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-corporate-office-headquarters",
      "poi_latitude": "29.4172323",
      "poi_longitude": "-98.4954226",
      "poi_miles_from_property": "13.6 mi",
      "poi_walking_minutes": "5 hours 5 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 210-938-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHfrImLFYXIYRkHGqxi9WgpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_aca0241577ee6d834c230a42",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "USAA Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9800 Fredericksburg Rd, San Antonio, TX 78288, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64ba-ee85-743e-a9ef-d21eaa7c6296.webp",
      "poi_featured_image_media": {
        "alt_text": "Large sculpture of the Statue of Liberty's torch in a building atrium.",
        "public_id": "019d64ba-ee85-743e-a9ef-d21eaa7c6296",
        "storage_key": "property/5637285756272640/019d64ba-ee85-743e-a9ef-d21eaa7c6296.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.usaa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7341051404387659836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "usaa-corporate-office",
      "poi_latitude": "29.5371902",
      "poi_longitude": "-98.5752478",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-531-8722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyyb6ITJnXIYRPLBolFun4GU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_3b41de7be806d1d9bdb6c7dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "poi_name": "Rackspace Technology",
      "poi_type": "Major Employers & Offices",
      "poi_address": "19122 U.S. Hwy 281 N Ste 128, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f1516-28b0-777d-92d8-9a2826702b7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-28b0-777d-92d8-9a2826702b7a",
        "storage_key": "property/5637285756272640/019f1516-28b0-777d-92d8-9a2826702b7a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.rackspace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10903605575149915578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rackspace-technology",
      "poi_latitude": "29.6183163",
      "poi_longitude": "-98.4634525",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-961-4454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d64bb-19c4-767d-b643-524df6d0f1b5",
        "storage_key": "property/5637285756272640/019d64bb-19c4-767d-b643-524df6d0f1b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkc1iXP7zXIYRuo3HNYBjUZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_3a0ede99-0c8d-4432-9013-c5c11cfab93a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_da32d8b2-a01a-4725-927e-635f407f17e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1a97dd57-4001-4671-906d-b9d5527877ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_19f01b75-7c2c-4e67-9b27-51034a258f03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "custom_a8d084f1-ad6a-4320-a9e9-4702d2f444cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "custom_fb0e9462-3569-4617-ac34-e001194735db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_dae2ce92008e474c8601837b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "rating": "5",
      "name": "Adriana Najera",
      "text": "Just moved in to Allure and so far I have nothing but great things to say! The neighbors are friendly and the ambiance is quiet. The front office is kind, respectful and most importantly RESPONSIVE!! If you have ever lived in other apartments you know what I’m talking about. My apartment was clean upon move in and there are no critters at all here thanks to the weekly pest control. All the staff was extremely helpful in my move in process including the awesome maintenance team. Special shoutout to Kat, Katherine and Ishmael for their help!!",
      "date": "2026-01-07",
      "title": "false"
    },
    {
      "id": "ec_557b5ce122430add9dde593e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "rating": "5",
      "name": "Marrianne Gross",
      "text": "⭐️⭐️⭐️⭐️⭐️ Love Love Love this apartment complex! 🥰 When it comes to maintenance Ishmael is ALWAYS on point! Not only is he super kind, he communicates well, resolves the issue & makes sure to see if there is any preventative maintenance that can be done so the same problem doesn’t happen again. 💪🏽 Thank you for all that you do Ish 💯 & thanks for having such an exceptional work ethic, it doesn’t go unnoticed 🙏🏽 Thank you to all of the Allure staff for making this a great place to live! 💕☕️ 💕 10 stars from me!! ⭐️⭐️⭐️⭐️⭐️",
      "date": "2026-04-07",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_96322708990eb69df2e3dec7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d02ee-f0cb-75ed-a5b2-8461a356bd43.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with a sofa, coffee table, TV, and access to a patio.",
        "public_id": "019d02ee-f0cb-75ed-a5b2-8461a356bd43",
        "storage_key": "property/5637285756272640/019d02ee-f0cb-75ed-a5b2-8461a356bd43.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 909SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?model=DsrWhhbVMJY"
    },
    {
      "id": "ec_cd7b61c2daea38155e71d057",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f14c4-d499-75ef-ad96-3a49236722b9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-d499-75ef-ad96-3a49236722b9",
        "storage_key": "property/5637285756272640/019f14c4-d499-75ef-ad96-3a49236722b9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?model=j219w4Hj9qg"
    },
    {
      "id": "ec_56662e8b091d6d0dc6f8a21b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019d02ee-f0cb-75ed-a5b2-8029d1a2e18e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious leasing office with a long wooden desk, comfortable seating, and a coffee station.",
        "public_id": "019d02ee-f0cb-75ed-a5b2-8029d1a2e18e",
        "storage_key": "property/5637285756272640/019d02ee-f0cb-75ed-a5b2-8029d1a2e18e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?model=dbT5TpLRo3L"
    }
  ],
  "faqs": [
    {
      "id": "custom_7e004b16-b101-4926-b3e6-ef65be4662ce",
      "question": "Is Allure at Shavano pet-friendly?",
      "answer": "Yes. Allure at Shavano welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (210) 408-6888 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_4eaa7ec2-80f3-42e2-8b43-116f7184aad5",
      "question": "How can I schedule a tour at Allure at Shavano?",
      "answer": "You can schedule a tour of Allure at Shavano online through our Schedule a Tour page, or call the leasing office at (210) 408-6888. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_6819e406-935d-4a0a-9f79-268cdea79442",
      "question": "What are the leasing office hours at Allure at Shavano?",
      "answer": "The Allure at Shavano leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (210) 408-6888 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_11c1fc0b-c1dd-42d0-a10f-de8e6001313a",
      "question": "What floor plans are available at Allure at Shavano?",
      "answer": "Allure at Shavano offers 1- and 2-bedroom apartment homes ranging from approximately 522 to 937 square feet, across 4 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_c7e805a7-af4d-4d0c-a6b9-d34455424abb",
      "question": "What amenities does Allure at Shavano have?",
      "answer": "Allure at Shavano offers a range of community and in-home amenities. Community amenities include: LUXER Package Locker, Access Gates, American Landmark 360, Dog Park, Fitness Center, Grill Area, Online Resident Services, Pool, Select Homes, Storage Spaces, and Cyber Cafe. In-home features include: built-in bookcase, built-in microwave, counters, hard floors, kitchen appliances, pantry closets, tile backsplash, w&d connections, and windows. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_14eb138b-ab7c-4085-a317-30e77794be4e",
      "question": "Where is Allure at Shavano located?",
      "answer": "Allure at Shavano is located at 4601 De Zavala Rd, San Antonio TX 78249. Nearby you'll find dining at Royal Pizza, shopping at Walmart Neighborhood Market, and green space at Gorrell Park. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_f17d5892-2b33-4585-93c2-c62a1f84a707",
      "question": "How do I apply to live at Allure at Shavano?",
      "answer": "You can apply to live at Allure at Shavano online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (210) 408-6888 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_e7553268-0b4b-4f3c-ad68-6f2b047b30eb",
      "question": "What do I need to apply at Allure at Shavano?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Allure at Shavano leasing team at (210) 408-6888 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_2ead433f-40fc-4803-90e1-6d9587ee4e78",
      "question": "What is the Landmark 360 program at Allure at Shavano?",
      "answer": "Allure at Shavano participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (210) 408-6888 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_f745745d-6f7b-4f24-b0ab-1c7bfeab8ea9",
      "question": "Does Allure at Shavano have a pool?",
      "answer": "Yes. Allure at Shavano has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_0669ed36-c855-4976-ad2a-892e7d98af09",
      "question": "Does Allure at Shavano have a fitness center?",
      "answer": "Yes. Allure at Shavano has a fitness center for residents. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_09b9c240-be59-4edf-9c78-fe5932ef2703",
      "question": "Does Allure at Shavano have a dog park?",
      "answer": "Yes. Allure at Shavano has an on-site dog park for residents and their dogs. See more community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_f78209eb-d12e-42d0-9bd7-47efe658cbe3",
      "question": "Does Allure at Shavano offer virtual tours?",
      "answer": "Yes. Allure at Shavano offers virtual tours of 2BR, 2BA - 909SF, Fitness Center, and Clubhouse. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_e0e0eb8d-5503-41ba-9ce9-ed25f7f03e64",
      "question": "What do residents say about living at Allure at Shavano?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at Allure at Shavano. One resident wrote: *\"Just moved in to Allure and so far I have nothing but great things to say! The neighbors are friendly and the ambiance is quiet. The front office is kind, respectful and most importantly RESPONSIVE!!\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_f114cac6-7582-4956-a19b-d20943ecc22d",
      "question": "When was Allure at Shavano built?",
      "answer": "Allure at Shavano was built in 1999. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_413dab60-69b0-441f-b692-93331e045cae",
      "question": "What is the pet fee at Allure at Shavano?",
      "answer": "Pets at Allure at Shavano: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (210) 408-6888 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_a288c4c9-c6c1-43d2-981b-de8204e04969",
      "question": "What features are included in the apartments at Allure at Shavano?",
      "answer": "Apartment homes at Allure at Shavano include built-in bookcase, built-in microwave, counters, hard floors, kitchen appliances, pantry closets, tile backsplash, w&d connections, and windows. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_31a417f4-cc33-414d-8bfb-7ac1d84f03ca",
      "question": "What restaurants and shops are near Allure at Shavano?",
      "answer": "Nearby restaurants and shops include Royal Pizza, Taqueria Datapoint-#3 -De Zavala Road Location, DeZavala Icehouse, and Chick-fil-A. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-234a-7664-848b-fcb1267927c3",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "allure-at-shavano",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640"
    },
    {
      "lead_collector_id": "0198aa45-23ac-7379-83a1-47b3dee189ab",
      "lead_source": "FACEBOOK_ADS",
      "name": "allure-at-shavano",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640"
    },
    {
      "lead_collector_id": "0198aa45-240f-7726-a04a-52fed706c661",
      "lead_source": "LANDING_PAGE",
      "name": "allure-at-shavano",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-san-antonio-tx",
      "search_query": "One Bedroom Apartments For Rent In San Antonio TX",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In San Antonio TX",
      "h2_subtitle": "Discover the perfect blend of comfort and convenience at Allure at Shavano. Our one-bedroom apartments offer modern amenities in a prime San Antonio location.",
      "page_copy": "Allure at Shavano features a variety of spacious one-bedroom apartments for rent in San Antonio, TX. Each unit is designed with your comfort in mind, featuring high-speed internet access, Wi-Fi, and washer/dryer hookups. Enjoy the luxury of granite countertops, stainless steel appliances, and a pantry in your kitchen. Additional features include built-in bookshelves and a smoke-free environment, making Allure at Shavano the ideal place to call home. Located at 4601 De Zavala Rd, our community is perfectly situated to provide easy access to all that San Antonio has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | One Bedroom Apartments For Rent In San Antonio TX",
      "seo_description": "Find one bedroom apartments for rent in San Antonio TX at Allure at Shavano. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-san-antonio-tx",
      "search_query": "Two Bedrooms Apartments For Rent In San Antonio TX",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In San Antonio TX",
      "h2_subtitle": "Experience spacious living at Allure at Shavano with our two-bedroom apartments. Enjoy modern amenities and a prime location in San Antonio, TX.",
      "page_copy": "Allure at Shavano features a variety of spacious two-bedroom apartments for rent in San Antonio, TX. Each apartment is thoughtfully designed to enhance your living experience, featuring high-speed internet access, Wi-Fi, and washer/dryer hookups. Enjoy the luxury of granite countertops, stainless steel appliances, and a pantry in your kitchen. Additional features include built-in bookshelves and a smoke-free environment, making Allure at Shavano the perfect place to call home. Located at 4601 De Zavala Rd, our community offers easy access to all that San Antonio has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Two Bedrooms Apartments For Rent In San Antonio TX",
      "seo_description": "Discover two bedrooms apartments for rent in San Antonio TX at Allure at Shavano. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Pool",
      "h2_subtitle": "Enjoy luxurious living at Allure at Shavano with our stunning pool. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent near me with pool access in San Antonio, TX. Our community amenities include a sparkling pool, a state-of-the-art fitness center, and a relaxing lounge. Pet owners will love our dog park, and the walk-up design adds convenience to your daily life. Each apartment is thoughtfully designed with high-speed internet access, Wi-Fi, and washer/dryer hookups. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to all that San Antonio has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent Near Me with Pool",
      "seo_description": "Find apartments for rent near me with pool access at Allure at Shavano in San Antonio, TX. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Fitness Center",
      "h2_subtitle": "Stay active and healthy at Allure at Shavano with our state-of-the-art fitness center. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent near me with fitness center access in San Antonio, TX. Our community amenities include a state-of-the-art fitness center, a sparkling pool, and a relaxing lounge. Pet owners will appreciate our dog park, and the walk-up design adds convenience to your daily life. Each apartment is thoughtfully designed with high-speed internet access, Wi-Fi, and washer/dryer hookups. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to all that San Antonio has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Find apartments for rent near me with fitness center access at Allure at Shavano in San Antonio, TX. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-lounge",
      "search_query": "Apartments For Rent Near Me with Lounge",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Lounge",
      "h2_subtitle": "Relax and unwind at Allure at Shavano with our inviting lounge. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent near me with lounge access in San Antonio, TX. Our community amenities include a comfortable lounge, a sparkling pool, and a state-of-the-art fitness center. Pet owners will love our dog park, and the walk-up design adds convenience to your daily life. Each apartment is thoughtfully designed with high-speed internet access, Wi-Fi, and washer/dryer hookups. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to all that San Antonio has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent Near Me with Lounge",
      "seo_description": "Find apartments for rent near me with lounge access at Allure at Shavano in San Antonio, TX. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-dog-park",
      "search_query": "Apartments For Rent Near Me with Dog Park",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Dog Park",
      "h2_subtitle": "Enjoy pet-friendly living at Allure at Shavano with our dedicated dog park. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent near me with dog park access in San Antonio, TX. Our community amenities include a dedicated dog park, a sparkling pool, and a state-of-the-art fitness center. Relax in our comfortable lounge, and enjoy the convenience of our walk-up design. Each apartment is thoughtfully designed with high-speed internet access, Wi-Fi, and washer/dryer hookups. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to all that San Antonio has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent Near Me with Dog Park",
      "seo_description": "Find apartments for rent near me with dog park access at Allure at Shavano in San Antonio, TX. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-walk-up",
      "search_query": "Apartments For Rent Near Me with Walk-Up",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Walk-Up",
      "h2_subtitle": "Experience the convenience of walk-up living at Allure at Shavano. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent near me with walk-up access in San Antonio, TX. Our community amenities include a convenient walk-up design, a sparkling pool, and a state-of-the-art fitness center. Relax in our comfortable lounge and enjoy the dedicated dog park for your furry friends. Each apartment is thoughtfully designed with high-speed internet access, Wi-Fi, and washer/dryer hookups. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to all that San Antonio has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent Near Me with Walk-Up",
      "seo_description": "Find apartments for rent near me with walk-up access at Allure at Shavano in San Antonio, TX. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-kitchen",
      "search_query": "Apartments For Rent Near Me with Kitchen",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Kitchen",
      "h2_subtitle": "Discover modern living at Allure at Shavano with our fully-equipped kitchens. Our San Antonio apartments offer top-notch amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent near me with kitchen access in San Antonio, TX. Each kitchen is thoughtfully designed with granite countertops, stainless steel appliances, and a pantry for all your storage needs. Enjoy the convenience of a microwave and high-speed internet access, along with Wi-Fi and washer/dryer hookups. Our smoke-free apartments also feature built-in bookshelves for added convenience. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to all that San Antonio has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent Near Me with Kitchen",
      "seo_description": "Find apartments for rent near me with kitchen access at Allure at Shavano in San Antonio, TX. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-granite-countertops",
      "search_query": "Apartments For Rent Near Me with Granite Countertops",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Granite Countertops",
      "h2_subtitle": "Experience luxury living at Allure at Shavano with our granite countertops. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent near me with granite countertops in San Antonio, TX. Each kitchen is designed to enhance your living experience with beautiful granite countertops, stainless steel appliances, and a convenient pantry. Enjoy the added benefits of a microwave, high-speed internet access, Wi-Fi, and washer/dryer hookups. Our smoke-free apartments also feature built-in bookshelves for your convenience. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to all that San Antonio has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent Near Me with Granite Countertops",
      "seo_description": "Find apartments for rent near me with granite countertops at Allure at Shavano in San Antonio, TX. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-stainless-steel",
      "search_query": "Apartments For Rent Near Me with Stainless Steel Appliances",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Stainless Steel Appliances",
      "h2_subtitle": "Upgrade your lifestyle at Allure at Shavano with our stainless steel appliances. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent near me with stainless steel appliances in San Antonio, TX. Each kitchen is thoughtfully designed to enhance your living experience with top-of-the-line stainless steel appliances, granite countertops, and a convenient pantry. Enjoy the added benefits of a microwave, high-speed internet access, Wi-Fi, and washer/dryer hookups. Our smoke-free apartments also feature built-in bookshelves for your convenience. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to all that San Antonio has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent Near Me with Stainless Steel Appliances",
      "seo_description": "Find apartments for rent near me with stainless steel appliances at Allure at Shavano in San Antonio, TX. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-pantry",
      "search_query": "Apartments For Rent Near Me with Pantry",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Pantry",
      "h2_subtitle": "Discover the convenience of pantry storage at Allure at Shavano. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent near me with pantry storage in San Antonio, TX. Each kitchen is thoughtfully designed to enhance your living experience with a convenient pantry, granite countertops, and stainless steel appliances. Enjoy the added benefits of a microwave, high-speed internet access, Wi-Fi, and washer/dryer hookups. Our smoke-free apartments also feature built-in bookshelves for your convenience. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to all that San Antonio has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent Near Me with Pantry",
      "seo_description": "Find apartments for rent near me with pantry storage at Allure at Shavano in San Antonio, TX. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-san-antonio-tx-near-wonderland",
      "search_query": "Apartments For Rent In San Antonio TX Near Wonderland of the Americas",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near Wonderland of the Americas",
      "h2_subtitle": "Discover the perfect home at Allure at Shavano, just minutes from Wonderland of the Americas. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent in San Antonio, TX near Wonderland of the Americas. Our thoughtfully designed interiors include high-speed internet access, Wi-Fi, and washer/dryer hookups. Enjoy luxurious features like granite countertops, stainless steel appliances, and a pantry in your kitchen. Community amenities include a lounge, walk-up access, a fitness center, a pool, and a dog park. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to shopping, dining, and entertainment at Wonderland of the Americas.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent In San Antonio TX Near Wonderland of the Americas",
      "seo_description": "Find apartments for rent in San Antonio TX near Wonderland of the Americas at Allure at Shavano. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-san-antonio-tx-near-methodist-hospital",
      "search_query": "Apartments For Rent In San Antonio TX Near Methodist Stone Oak Hospital",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near Methodist Stone Oak Hospital",
      "h2_subtitle": "Find your ideal home at Allure at Shavano, conveniently located near Methodist Stone Oak Hospital. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent in San Antonio, TX near Methodist Stone Oak Hospital. Our thoughtfully designed interiors include high-speed internet access, Wi-Fi, and washer/dryer hookups. Enjoy luxurious features like granite countertops, stainless steel appliances, and a pantry in your kitchen. Community amenities include a lounge, walk-up access, a fitness center, a pool, and a dog park. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to the exceptional medical care and services offered at Methodist Stone Oak Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent In San Antonio TX Near Methodist Stone Oak Hospital",
      "seo_description": "Find apartments for rent in San Antonio TX near Methodist Stone Oak Hospital at Allure at Shavano. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-san-antonio-tx-near-methodist-childrens-hospital",
      "search_query": "Apartments For Rent In San Antonio TX Near Methodist Children's Hospital",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near Methodist Children's Hospital",
      "h2_subtitle": "Find your perfect home at Allure at Shavano, conveniently located near Methodist Children's Hospital. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent in San Antonio, TX near Methodist Children's Hospital. Our thoughtfully designed interiors include high-speed internet access, Wi-Fi, and washer/dryer hookups. Enjoy luxurious features like granite countertops, stainless steel appliances, and a pantry in your kitchen. Community amenities include a lounge, walk-up access, a fitness center, a pool, and a dog park. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to the exceptional pediatric care and services offered at Methodist Children's Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent In San Antonio TX Near Methodist Children's Hospital",
      "seo_description": "Find apartments for rent in San Antonio TX near Methodist Children's Hospital at Allure at Shavano. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-san-antonio-tx-near-university-health",
      "search_query": "Apartments For Rent In San Antonio TX Near University Health University Hospital",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near University Health University Hospital",
      "h2_subtitle": "Experience convenient living at Allure at Shavano, located near University Health University Hospital. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent in San Antonio, TX near University Health University Hospital. Our thoughtfully designed interiors include high-speed internet access, Wi-Fi, and washer/dryer hookups. Enjoy luxurious features like granite countertops, stainless steel appliances, and a pantry in your kitchen. Community amenities include a lounge, walk-up access, a fitness center, a pool, and a dog park. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to the comprehensive medical services and care offered at University Health University Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent In San Antonio TX Near University Health University Hospital",
      "seo_description": "Find apartments for rent in San Antonio TX near University Health University Hospital at Allure at Shavano. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-san-antonio-college-san-antonio-tx",
      "search_query": "Apartments For Rent In San Antonio TX Near San Antonio College",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near San Antonio College",
      "h2_subtitle": "Discover convenient living at Allure at Shavano, located near San Antonio College. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent in San Antonio, TX near San Antonio College. Our thoughtfully designed interiors include high-speed internet access, Wi-Fi, and washer/dryer hookups. Enjoy luxurious features like granite countertops, stainless steel appliances, and a pantry in your kitchen. Community amenities include a lounge, walk-up access, a fitness center, a pool, and a dog park. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to the educational opportunities and vibrant campus life at San Antonio College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent In San Antonio TX Near San Antonio College",
      "seo_description": "Find apartments for rent in San Antonio TX near San Antonio College at Allure at Shavano. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-san-antonio-tx-near-university-incarnate-word",
      "search_query": "Apartments For Rent In San Antonio TX Near University of the Incarnate Word",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near University of the Incarnate Word",
      "h2_subtitle": "Find your ideal home at Allure at Shavano, conveniently located near the University of the Incarnate Word. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent in San Antonio, TX near the University of the Incarnate Word. Our thoughtfully designed interiors include high-speed internet access, Wi-Fi, and washer/dryer hookups. Enjoy luxurious features like granite countertops, stainless steel appliances, and a pantry in your kitchen. Community amenities include a lounge, walk-up access, a fitness center, a pool, and a dog park. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to the educational opportunities and vibrant campus life at the University of the Incarnate Word.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent In San Antonio TX Near University of the Incarnate Word",
      "seo_description": "Find apartments for rent in San Antonio TX near the University of the Incarnate Word at Allure at Shavano. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-san-antonio-tx-near-st-marys-university",
      "search_query": "Apartments For Rent In San Antonio TX Near St. Mary's University",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near St. Mary's University",
      "h2_subtitle": "Experience convenient living at Allure at Shavano, located near St. Mary's University. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent in San Antonio, TX near St. Mary's University. Our thoughtfully designed interiors include high-speed internet access, Wi-Fi, and washer/dryer hookups. Enjoy luxurious features like granite countertops, stainless steel appliances, and a pantry in your kitchen. Community amenities include a lounge, walk-up access, a fitness center, a pool, and a dog park. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to the educational opportunities and vibrant campus life at St. Mary's University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent In San Antonio TX Near St. Mary's University",
      "seo_description": "Find apartments for rent in San Antonio TX near St. Mary's University at Allure at Shavano. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-san-antonio-tx-near-northwest-vista",
      "search_query": "Apartments For Rent In San Antonio TX Near Northwest Vista College",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near Northwest Vista College",
      "h2_subtitle": "Discover convenient living at Allure at Shavano, located near Northwest Vista College. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent in San Antonio, TX near Northwest Vista College. Our thoughtfully designed interiors include high-speed internet access, Wi-Fi, and washer/dryer hookups. Enjoy luxurious features like granite countertops, stainless steel appliances, and a pantry in your kitchen. Community amenities include a lounge, walk-up access, a fitness center, a pool, and a dog park. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to the educational opportunities and vibrant campus life at Northwest Vista College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent In San Antonio TX Near Northwest Vista College",
      "seo_description": "Find apartments for rent in San Antonio TX near Northwest Vista College at Allure at Shavano. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5637285756272640",
      "source": "custom",
      "page_item_url": "apartments-for-rent-san-antonio-tx-near-koehler-house",
      "search_query": "Apartments For Rent In San Antonio TX Near The Koehler House",
      "category": "POI",
      "h1_title": "Apartments For Rent In San Antonio TX Near The Koehler House",
      "h2_subtitle": "Experience historic charm at Allure at Shavano, located near The Koehler House. Our San Antonio apartments offer modern amenities and a prime location.",
      "page_copy": "Allure at Shavano features a variety of spacious apartments for rent in San Antonio, TX near The Koehler House. Our thoughtfully designed interiors include high-speed internet access, Wi-Fi, and washer/dryer hookups. Enjoy luxurious features like granite countertops, stainless steel appliances, and a pantry in your kitchen. Community amenities include a lounge, walk-up access, a fitness center, a pool, and a dog park. Located at 4601 De Zavala Rd, Allure at Shavano is ideally situated to provide easy access to the historic charm and cultural significance of The Koehler House.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a gray sofa, ottoman, coffee table, and TV stand.",
        "public_id": "019f6c0b-48f9-7778-b022-7ea000465c22",
        "storage_key": "property/5637285756272640/019f6c0b-48f9-7778-b022-7ea000465c22.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-5838-72e4-b0c2-d2924be5b976",
        "storage_key": "property/5637285756272640/019f6c0b-5838-72e4-b0c2-d2924be5b976.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Allure at Shavano | Apartments For Rent In San Antonio TX Near The Koehler House",
      "seo_description": "Find apartments for rent in San Antonio TX near The Koehler House at Allure at Shavano. Enjoy modern amenities and a prime location. Contact us today for availability!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2297"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2505043969"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a13\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a13\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4981180"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NRXX34W"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443872083"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "b741cd8bc2011f12"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/1ywyjgl0wq0"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/544c7543-615e-4132-b556-262612ad1f31"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "361-321-6651"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjB5L2kzOURTQ1ZUamp1TFBlNXVVV3c9PSIsInZhbHVlIjoid0V4WmJYNVNwWVJ0YTR5ekY4WHRzQT09IiwibWFjIjoiMDM1ZmEzYjQ0Zjg1Y2FmNzdlZjU2NDIzNzQ0MWFkNzQ2YmQ1ZjE3ZTllNzNmMzEwNWYyNThhNDU3ZGRmNjFjMyJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2297",
  "custom_repli_id": "2505043969",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a13\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a13\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4981180",
  "custom_google_gtm_id": "GTM-NRXX34W",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443872083",
  "custom_knock_community_id": "b741cd8bc2011f12",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/1ywyjgl0wq0",
  "custom_self_guided_tour_url": "https://selftournow.com/property/544c7543-615e-4132-b556-262612ad1f31",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "361-321-6651",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjB5L2kzOURTQ1ZUamp1TFBlNXVVV3c9PSIsInZhbHVlIjoid0V4WmJYNVNwWVJ0YTR5ekY4WHRzQT09IiwibWFjIjoiMDM1ZmEzYjQ0Zjg1Y2FmNzdlZjU2NDIzNzQ0MWFkNzQ2YmQ1ZjE3ZTllNzNmMzEwNWYyNThhNDU3ZGRmNjFjMyJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-19T19:03:22.935Z';
